/*
Compile with npm run dev
Navigate to http://localhost:8081/index.html   (ensure service/public is running)
*/

import { simpleDateFormat } from './utils/simpleDateFormat';
import { capitalizeFirstLetter } from './utils/stringUtils';

declare var echarts: any;
declare var jQuery: any;
class AnnouncementTableOptions {
  announcementDateFormat: string;
  announcementLocale: string;
  hidePriceSensitive: boolean;
  numAnnouncements: number;
}

interface IApiKeyWrapper {
  apiKey:string
  marketData?:StockMarketData
  announcements?:Announcement[]
  chartData?:StockData[]
  secFilingResult?:ISecFilingResult
  subscriptionExpired?:boolean
}
interface AnnouncementFilterOptions {
  priceSensitiveOnly:boolean;
  filterRegex:string;
  maxYears:number;
  startYear:number;
  tags?:string[];
}

interface ISecFilingResult{
  secFilings:SecFiling[]
}
interface SecFiling{
  date:string
  form:string
  description:string
  files:SecFilingDocument[]
}
interface SecFilingDocument{
  secFilingDocumentType: SecFilingDocumentType
  url:string
}
enum SecFilingDocumentType {
  None,
  Html,
  Zip,
  Pdf,
  Xml
}
type InputType = 'textarea' | 'text' | 'email' | 'checkbox';

type CommentsWordingType = 'comment' | 'question';

interface SearchBoxOptions {
  getTextFunc?:(row:HTMLElement)=>string
  onkeyup?:(ev:KeyboardEvent)=>void
  locale?:string
}

interface ChartCustomColors {
  priceGradientStart?: string;
  priceGradientEnd?: string;
  volumeColor?: string;
  zoomButtonBg?: string;
  zoomButtonText?: string;
  zoomButtonActiveBg?: string;
}

interface IWidgetElement<T> extends HTMLElement{
  investi:T
}

interface AnnouncementsTabWidgetElement extends IWidgetElement<AnnouncementsTabWidgetData> {

}

interface AnnouncementsTabWidgetData extends IPaginationWidgetData, IDetailViewData {
  year:number
  priceSensitiveSymbol:string
  listScrollY?:number
}

//widgets that open an announcement in place (v2, tabs on its dedicated page)
interface IDetailViewData {
  pdfViewer?:PdfViewer
}

interface IWidgetData {

}
interface IPaginationWidgetData extends IWidgetData {
  page:number
  numPerPage:number;
  rowClassName:string;
  locale?:string;
}

interface AnnouncementsInteractiveWidgetElement extends IWidgetElement<AnnouncementsInteractiveWidgetData> {

}

interface AnnouncementsInteractiveWidgetData extends IPaginationWidgetData, IDetailViewData {
  announcements:Announcement[]
  selected?:Announcement
  selectedElem?:HTMLElement
  page:number
  apiKey:string
  noComments: boolean
  commentsWordingType:CommentsWordingType
  v2?:boolean
  loginLink?:string
  me?:{loggedIn:boolean, name?:string, email?:string}
}

interface AnnouncementCommentRequest {
    apiKey: string;
    announcementGuid: string;
    name: string;
    email: string;
    comment: string;
    isPrivate:boolean
    locationHref:string
    captchaToken:string
}

interface AnnouncementCommentResult {
    errorMessage: string;
    message?: string;
}

interface AddSubscriberRequest {
  apiKey: string;
  firstName: string;
  lastName: string;
  email: string;
  tags?: string[];
}

interface AddSubscriberResult {
  errorMessage: string;
  feedback: string;
}

interface AnnouncementCommentsResult {
    comments: AnnouncementCommentApi[];
    errorMessage: string;
}

interface AnnouncementCommentApi {
    name: string;
    comment: string;
    responses: AnnouncementCommentApi[];
    date: string;
}


const SharePriceWidgetName = 'investi-share-price';
const HeaderPriceWidgetName = 'investi-header-price-widget';
const HeaderPriceWidgetNamev2 = 'investi-header-price';
const PriceOnTopWidgetName = 'investi-price-on-top-widget';
const SharePriceTable = 'investi-share-price-table';
const SharePriceChartWidgetName = 'investi-share-price-chart';
const HighstockScriptPattern = /highstock(\.src)?\.js/i;

const SharePriceLastElementName = 'investi-share-price-last';
const SharePriceSymbolElementName = 'investi-share-price-symbol';
const SharePriceVolumeElementName = 'investi-share-price-volume';
const SharePriceLow52WeekElementName = 'investi-share-price-low52Week';
const SharePriceLowElementName = 'investi-share-price-low';
const SharePriceAskElementName = 'investi-share-price-ask';
const SharePricePrevCloseElementName = 'investi-share-price-prevClose';
const SharePriceOpenElementName = 'investi-share-price-open';
const SharePriceHigh52WeekElementName = 'investi-share-price-high52Week';
const SharePriceHighElementName = 'investi-share-price-high';
const SharePriceBidElementName = 'investi-share-price-bid';
const SharePriceMovement = 'investi-share-price-movement';
const SharePriceMovementPercent = 'investi-share-price-movement-percent';
const ShareMarketCapName = 'investi-market-cap';
const SharesOnIssueName = 'investi-shares-on-issue';
const SharePriceUpdateTime = 'investi-share-price-update-time';
const SharePriceUpdateDate = 'investi-share-price-update-date';
const SharePriceUpdated = 'investi-share-price-updated';




const AnnouncementsWidgetName = 'investi-announcements';
const AnnouncementsSummaryWidgetName = 'investi-announcements-summary';
const AnnouncementsSummaryv2WidgetName = 'investi-announcements-summary-v2';
const AnnouncementsAccordionWidgetName = 'investi-announcements-accordion';
const AnnouncementsTabWidgetName = 'investi-announcements-tab';
const AnnouncementsCarouselWidgetName = 'investi-carousel';
const AnnouncementsInteractiveWidgetName = 'investi-interactive-announcements';
const AnnouncementsInteractiveV2WidgetName = 'investi-interactive-announcements-v2';
const AnnouncementsLatestPresentationWidgetName = 'investi-latest-presentation';
const AnnouncementsReportsWidgetName = 'investi-reports';
const AnnouncementsThumbnailWidgetName = 'investi-announcements-thumbnail';
const StoriBotWidgetName = 'investi-storibot';

const AddSubscriberWidgetName = 'investi-add-subscriber';
const LoginWidgetName = 'investi-login';
const NavAccountWidgetName = 'investi-nav-account';

const MovementUnchangedTextAttrName:string = 'data-investi-movement-unchanged-text'

const AnnouncementDataWidgetNames:string[] = [
  AnnouncementsWidgetName,
  AnnouncementsSummaryWidgetName,
  AnnouncementsSummaryv2WidgetName,
  AnnouncementsAccordionWidgetName,
  AnnouncementsTabWidgetName,
  AnnouncementsCarouselWidgetName,
  AnnouncementsInteractiveWidgetName,
  AnnouncementsInteractiveV2WidgetName,
  AnnouncementsLatestPresentationWidgetName,
  AnnouncementsReportsWidgetName,
  AnnouncementsThumbnailWidgetName,
  StoriBotWidgetName
];

const MarketDataElemNames:string[] = [
  SharePriceLastElementName,
  SharePriceMovement,
  SharePriceMovementPercent,
  ShareMarketCapName,
  SharesOnIssueName,
  SharePriceUpdateTime,
  SharePriceUpdateDate,
  SharePriceSymbolElementName,
  SharePriceVolumeElementName,
  SharePriceLow52WeekElementName,
  SharePriceLowElementName,
  SharePriceAskElementName,
  SharePricePrevCloseElementName,
  SharePriceOpenElementName,
  SharePriceHigh52WeekElementName,
  SharePriceHighElementName,
  SharePriceBidElementName,
  SharePriceUpdated
]

const RequiresMarketDataNames:string[] = [
  ...MarketDataElemNames,
  SharePriceWidgetName,
  HeaderPriceWidgetName,
  PriceOnTopWidgetName,
  SharePriceTable,
  SharePriceChartWidgetName //required to get the ticker or header
];


const SecFilingsWidgetName = 'investi-sec-filings';

const WidgetCreatedAttrName:string = 'data-investi-widget-created';
const AnnouncementSlugPathRegex = /\/(?:[^/]*-)?asx-[0-9a-f]{8}(?:-[0-9a-f]{3})?\/?$/;
const ShowingDetailClassName = 'investi-v2-showing-detail';

const SubscriptionExpiredMessage = 'Investi subscription expired. Contact Investi Support contact@investi.com.au'
const LastLoginStorageKey = 'investi-last-login' // set on login, never cleared: "has logged in on this browser"

class InvestiWidget {

  baseAddress: string = "";
  authBaseAddress: string = "";
  apiKeys: IApiKeyWrapper[] = [];
  activatedClassName:string = 'investi-announcements-accordion-year-activated';

  constructor() {

    this.apiKeys = this.getApiKeys();

    let currentScriptSrc = (document.currentScript as any).src || '';
    if(process.env.NODE_ENV === "development"){
      this.baseAddress = "http://localhost:5000";
      //  this.baseAddress = "https://api.investi.com.au";
    }else if(currentScriptSrc.includes('dev.investi.com.au')){
      this.baseAddress = new URL(currentScriptSrc).origin;
    }else{
      // api.investi.com.au is the only valid prod API host. www/root 301-redirect /api/*,
      // which downgrades POST->GET, and customer domains never serve the API.
      this.baseAddress = `${window.location.protocol}//api.investi.com.au`;
    }
    // console.log(`using baseAddress: ${this.baseAddress}`)

    // auth calls must be first-party so the session cookie survives third-party cookie blocking:
    // investors[-dev].<page domain>, whose cookie is scoped to .<page domain>
    if(process.env.NODE_ENV === "development"){
      this.authBaseAddress = this.baseAddress;
    }else{
      const prefix = currentScriptSrc.includes('dev.investi.com.au') ? 'investors-dev' : 'investors';
      this.authBaseAddress = `https://${prefix}.${this.getRootDomain(window.location.hostname)}`;
    }

  }

  // www.staging2.49metals.com.au -> 49metals.com.au
  getRootDomain(hostname: string): string {
    const parts = hostname.split('.');
    const keep = /\.(com|net|org|asn|co)\.(au|nz|uk)$/.test(hostname) ? 3 : 2;
    return parts.slice(-keep).join('.');
  }

  getApiKeys() : IApiKeyWrapper[]{
    const apiKey = this.getParam('apiKey');
    let arr = [];
    if(apiKey){
      arr = apiKey.split(',').map(value => value.trim());;
    }

    // Select all elements with 'investi' in their id or class
    const allInvestiElements = [
      ...Array.from(document.querySelectorAll('[id^="investi"]')),
      ...Array.from(document.querySelectorAll('[class^="investi"]'))
    ];

    // Loop through the elements and add apiKey values
    allInvestiElements.forEach(element => {
      let apiKeyAttr = element.getAttribute('apikey');
      if (apiKeyAttr) {
        let trimmedApiKey = apiKeyAttr.trim();
        if (!arr.includes(trimmedApiKey)) {
          arr.push(trimmedApiKey);
        }
      }
    });


    return arr.map(x=> ({ apiKey: x, ticker: '' }));


  }

  createInvestiSharePriceWidget(elemId?: string) {

    if(elemId){
      //not sure who uses this but we have to support passing in the elemId
      let elem: HTMLElement = document.getElementById(elemId);
      elem.innerHTML = this.getSharePriceWidgetHTML();
      const apiKey = elem.getAttribute('apiKey');
      this.getMarketData(apiKey, data => {
        this.setInvestiSharePriceWidget(data, elem);
      });
    }else{

      this.doActionOnIdOrClass(SharePriceWidgetName, (elem, apiKey) => {
        elem.innerHTML = this.getSharePriceWidgetHTML();
        this.getMarketData(apiKey, data => {
          this.setInvestiSharePriceWidget(data, elem);
        });
      });
    }
  }


  getSharePriceWidgetHTML(){
    return `<div class="market-data-header">LATEST SHARE PRICE</div>
    <div class="market-data-header"><span class="investi-stock-exchange"></span>:<span id="market-data-ticker">
       </span>
    </div>
    <div class="investi-market-data-last-container"> <span id="market-data-last"></span> </div>
    <div class="market-data-movement-section">
       <span id="market-data-movement"></span><span id="market-data-movementPercent"></span>
    </div>
    <div class="market-data-updated-section">
       <table>
          <tbody>
             <tr>
                <td>UPDATED</td>
                <td><span id="market-data-updated"></span></td>
             </tr>
             <tr>
                <td>EXCHANGE</td>
                <td><span class="investi-stock-exchange"></span></td>
             </tr>
             <tr>
                <td>CURRENCY</td>
                <td><span class="investi-stock-currency"></span></td>
             </tr>
          </tbody>
       </table>
    </div>
     `;
  }

  shouldPollMarketData() : boolean {

    for (let elem of RequiresMarketDataNames) {
      if (document.getElementById(elem) != null){
        return true;
      }
      if (document.getElementsByClassName(elem).length > 0){
        return true;
      }
    }
    return false;
  }

  hasAnnouncementWidget() : boolean {

    for (let elem of AnnouncementDataWidgetNames) {
      if (document.getElementById(elem) != null){
        return true;
      }
      if (document.getElementsByClassName(elem).length > 0){
        return true;
      }
    }
    return false;
  }

  ensureContainer(apiKey:string|null) {
    apiKey = apiKey || this.apiKeys[0].apiKey;
    let container = this.apiKeys.find(x=>x.apiKey===apiKey);
    if(!container){
      console.warn(`apiKey not defined in url. will still work but is less efficient`)
      container = { apiKey };
      this.apiKeys.push(container);
    }
    return container;
  }

  getMarketData(apiKey:string|null, callback:(wrapper:IApiKeyWrapper)=>void, onError?:(e:any)=>void) {
    const container = this.ensureContainer(apiKey);
    if (!container.marketData) {
      // console.log(`sendRequest market data`, apiKey)
      this.sendRequest('/api/marketdata', apiKey,
        json => {
          this.setContainerField(container, json, x =>container.marketData = x)
          callback(container);
        },
        onError);
    } else {
      //console.log(`using cached market data`, container.marketData)
      callback(container);
    }
  }

  setContainerField(container:IApiKeyWrapper, json:string, setter:(obj:any)=>void){
    const deserialized = JSON.parse(json);
    if(this.isSubscriptionExpired(deserialized)){
      console.warn(`subscription has expired`)
      container.subscriptionExpired = true;
    }else{
      setter(deserialized)
    }

  }

  isSubscriptionExpired(deserialized:any){
    return deserialized["subscriptionExpired"] === true;
  }

  getAnnouncementData(apiKey:string|null, callback:(wrapper:IApiKeyWrapper)=>void, onError?:(e:any)=>void) {
    const container = this.ensureContainer(apiKey);
    if (!container.announcements) {
      this.sendRequest('/api/announcements', apiKey,
        json => {
          const setter = x => {
            for(let announcement of x){
              if(announcement.videoUrl === undefined){
                announcement["videoUrl"] = '';
              }
              if(announcement.videoDescription === undefined){
                announcement["videoDescription"] = '';
              }
            }

            container.announcements = x
          };
          this.setContainerField(container, json, setter)
          callback(container);
        },
        onError);
    } else {
      callback(container);
    }
  }

  getDollarSign(currency:string){
    if(currency == 'GBP')
      return '£'
    if(currency == 'AUD')
      return '$'
    if(currency == 'EUR')
      return '€'
    return '';
  }

  setInvestiSharePriceWidget(container:IApiKeyWrapper, elem: HTMLElement,  dollarSign?:string) {
    if(this.checkSubscriptionExpired(elem, container))
      return;

    const data:StockMarketData = container.marketData
    let date = new Date(data.updated);

    if(elem != null){
      dollarSign = dollarSign || this.getDollarSign(data.currency);

      this.setElementWithData('market-data-last', `<span class="market-data-last-dollar-sign">${dollarSign}</span>` + this.addZeroes(data.last, elem), elem);

      let movementElem = elem.querySelector('#market-data-movement');
      let movementPercentElem = elem.querySelector('#market-data-movementPercent');
      if (movementElem != null && movementPercentElem != null)
        this.setMovementElem(data, movementElem, movementPercentElem, elem);

      //var updated = moment(data.updated).format('DD MMM HH:mm') + ' - ' + moment(data.currentMarketData.updated).fromNow();

      var updated = this.formatDate(date);
      this.setElementWithData('market-data-updated', updated, elem);
      this.setElementWithData('market-data-ticker', data.ticker, elem);
      for (let exchangeElem of <any>elem.getElementsByClassName('investi-stock-exchange')) {
        exchangeElem.innerText = data.exchange;
      }
      for (let exchangeElem of <any>elem.getElementsByClassName('investi-stock-currency')) {
        exchangeElem.innerText = data.currency;
      }

    }else{
      let movementElem = document.querySelector<HTMLElement>('#market-data-movement');
      let movementPercentElem = document.querySelector('#market-data-movementPercent');
      if (movementElem != null && movementPercentElem != null)
        this.setMovementElem(data, movementElem, movementPercentElem, movementElem);
    }

  }

  setMarketCap(elem:HTMLElement, data:StockMarketData) {

    if(elem != null){
      let suffix = "M";
      // let amt = Math.round(data.marketCap / 1000000)
      let amt = data.marketCap / 1000000;
      const rounding = parseInt(elem.getAttribute('data-investi-market-cap-rounding'));
      if(amt > 1000){
        amt = parseFloat((amt / 1000).toFixed(rounding || 1))
        suffix = "B";
      }else{
         amt = parseFloat((amt).toFixed(rounding || 0))
      }

      var amountElement: HTMLElement = document.createElement('span');
      amountElement.className = 'investi-market-cap-amount'
      amountElement.innerText = amt.toLocaleString();
      elem.append(amountElement)

      var suffixElement: HTMLElement = document.createElement('span');
      suffixElement.className = 'investi-market-cap-suffix'
      suffixElement.innerText = suffix;
      elem.append(suffixElement)
    }
  }

  setMarketDataFieldWithCommas(elem:HTMLElement, field:number) {
    if(elem != null){
      elem.innerText = field.toLocaleString();
    }
  }

  setSharePriceMovementPercent(elem:HTMLElement, movementPercent:number) {

    if(elem != null){
      let prefix = '';
      let className = 'investi-movement-percent-no-movement';
      if(movementPercent > 0){
        prefix = '+';
        className = 'investi-movement-percent-up';
      }else if(movementPercent < 0){
        prefix = '-';
        className = 'investi-movement-percent-down';
      }
      elem.className = className;

      var plusminusSpan: HTMLElement = document.createElement('span');
      plusminusSpan.className = "investi-share-price-movement-percent-plusminus";
      plusminusSpan.innerText = prefix;
      elem.append(plusminusSpan);

      const textSpan: HTMLElement = document.createElement('span');
      textSpan.className = "investi-share-price-movement-percent-text";
      textSpan.innerText = this.getFormattedMarketDataNumericField(Math.abs(movementPercent), elem)
      elem.append(textSpan);
    }
  }

  setSharePriceMovement(elem:HTMLElement, data:StockMarketData) {

    let className = 'investi-movement-no-movement';
    if(elem){
      const movement:number = data.movement;
      let prefix = '';
      if(movement > 0){
        prefix = '+';
        className = 'movement-up';
      }else if(movement < 0){
        prefix = '-';
        className = 'movement-down';
      }

      elem.className = className;

      const plusminusSpan: HTMLElement = document.createElement('span');
      plusminusSpan.className = "investi-share-price-movement-plusminus";
      plusminusSpan.innerText = prefix;
      elem.append(plusminusSpan);

      const textSpan: HTMLElement = document.createElement('span');
      textSpan.className = "investi-share-price-movement-text";
      const unchangedText = elem.getAttribute(MovementUnchangedTextAttrName);
      const movementText = (movement == 0 && unchangedText) ? unchangedText : this.addZeroes(Math.abs(movement), elem);
      textSpan.innerText = this.getDollarSign(data.currency) + movementText
      elem.append(textSpan);


    }

  }
  //https://stackoverflow.com/a/24039448/224410
  addZeroes(num:any, elem:HTMLElement) :any{

    if(num==0){
      return this.getFormattedMarketDataNumericField(num, elem);
    }

    num = num+'';
    // Convert input string to a number and store as a variable.
    var value:any = Number(num);
    // Split the input string into two arrays containing integers/decimals
    var res = num.split(".");
    // If there is no decimal point or only one decimal place found.
    if (res.length <= 2) {
      // Set the number to two decimal places or more if explicitly defined
      value = this.getFormattedMarketDataNumericField(value, elem);
    }
    // Return updated or original number.
    return value;
  }

  setElementWithData(elemId:string, data:string, parent?: HTMLElement) {
    let elem = parent != null ? parent.querySelector('#'+elemId) : document.getElementById(elemId);

    if(elem)
      elem.innerHTML = data;
  }

  setMovementElem(data, movementElem, movementPercentElem, widget:HTMLElement) {
    const unchangedText = widget.getAttribute(MovementUnchangedTextAttrName);
    let movementStr = data.movement;
    let movementColorClass = '';
    if (data.movement > 0) {
      movementStr = "+" + movementStr;
      movementColorClass = 'movement-up';
    }
    else if (data.movement < 0) {
      movementColorClass = 'movement-down';
    }
    else{
      movementColorClass = 'movement-unchanged';
      if(data.movement == 0 && unchangedText){
        movementStr = unchangedText;
      }
    }

    movementElem.innerHTML = movementStr;
    movementElem.className += ' ' + movementColorClass;
    const movementPercent = this.getFormattedMarketDataNumericField(data.movementPercent, movementElem)

    movementPercentElem.innerHTML = movementPercent + '%';
    movementPercentElem.className += ' ' + movementColorClass;
  }

async sendRequest(route: string, apiKey: string, callback: (response: string) => void, onError?:(e:any)=>void) {
  const maxAttempts = 3;
  const delayMs = 200;

  apiKey = apiKey || (this.apiKeys.length ? this.apiKeys[0].apiKey : null);
  if (!apiKey) throw new Error('apiKey must be defined.');

  const url = this.buildUrl(route, apiKey);

  const attemptRequest = async (attempt: number): Promise<void> => {
    try {
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.text();
        callback(data);
      } else {
        throw new Error(`HTTP ${response.status}`);
      }
    } catch (err) {
      console.warn(`Attempt ${attempt} failed: ${err}`);
      if (attempt < maxAttempts) {
        await this.delay(delayMs);
        return attemptRequest(attempt + 1);
      } else {
        const err = `sendRequest failed after ${maxAttempts} attempts for apiKey:${apiKey}`;
        if(onError){
          onError(err);
        }else{
          console.warn(err)
        }
      }
    }
  };

  await attemptRequest(1);
}

buildUrl(route: string, apiKey: string): string {
  const separator = route.includes('?') ? '&' : '?';
  return `${this.baseAddress}${route}${separator}apiKey=${apiKey}`;
}

delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}


  getParam(name:string):string {
    let elements = document.getElementsByTagName('script');
    for (let i = 0; elements[i]; i++) {
      var srcAttr: string = elements[i].getAttribute('src');
	  if (srcAttr && /investi\.js/.test(srcAttr)) {
        return this.getParameterByName(name, srcAttr);
      }
    }
    return null;
  }

  getParameterByName(name, url):string {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  monthNames:string[] = [
    "Jan", "Feb", "Mar",
    "Apr", "May", "Jun", "Jul",
    "Aug", "Sep", "Oct",
    "Nov", "Dec"
  ];
  formatDate(date) {


    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return day + ' ' + this.monthNames[monthIndex] + ' ' + this.formatAMPM(date);
  }
  formatDateOnly(date) {
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    return day + ' ' + this.monthNames[monthIndex] + ' ' + year;
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  createInvestiChart() {
    const highstockOnPage = Array.from(document.scripts).some(s => HighstockScriptPattern.test(s.src));
    this.doActionOnIdOrClass(SharePriceChartWidgetName, (elem, apiKey) => {
      if (highstockOnPage) { elem.remove(); return; }

      this.getChartData(apiKey, (container:IApiKeyWrapper) => {
        this.createChart(elem, container);
      });
    });
  }

  createInvestiSharePriceTable() {
    this.doActionOnIdOrClass(SharePriceTable, (elem, apiKey) => {

      this.getMarketData(apiKey, data => {
        this.createSharePriceTable(elem, data);
      });
    });
  }

  checkSubscriptionExpired(elem: HTMLElement, container:IApiKeyWrapper) : boolean {
    if(container.subscriptionExpired === true){
      elem.innerText = SubscriptionExpiredMessage;
      return true;
    }
    return false;
  }

  createSharePriceTable(elem: HTMLElement, container:IApiKeyWrapper) {

    if(this.checkSubscriptionExpired(elem, container))
      return;

    const data:StockMarketData = container.marketData;
    const apiKey = elem.getAttribute('apiKey') || '';
    const attrVal = elem.getAttribute('investi-num-decimal-places');
    let dpAttr = '';
    if(parseInt(attrVal)){
      dpAttr = `investi-num-decimal-places="${attrVal}"`;
    }

    const locale = this.getLocale(elem);
    
    elem.innerHTML = `<div class="investi-market-data-container">
    <div class="investi-market-data-field-name">${this.translate('Symbol:', locale)} </div>
    <div class="investi-share-price-symbol" apiKey="${apiKey}"></div>
    <div class="investi-market-data-field-name">${this.translate('Share Price:', locale)} </div>
    <div class="investi-share-price-last" data-investi-prefix-currency-symbol apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">${this.translate('Market Cap:', locale)} $</div>
    <div class="investi-market-cap" apiKey="${apiKey}"></div>
    <div class="investi-market-data-field-name">${this.translate('Shares on Issue:', locale)} </div>
    <div class="investi-shares-on-issue" apiKey="${apiKey}"></div>
    <div class="investi-market-data-field-name">${this.translate('% Change:', locale)} </div>
    <div class="investi-share-price-movement-percent" apiKey="${apiKey}"></div>

    <div class="investi-market-data-field-name">${this.getDollarSign(data.currency)} ${this.translate('Change:', locale)} </div>
    <div class="investi-share-price-movement" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">${this.translate('Volume:', locale)} </div>
    <div class="investi-share-price-volume" apiKey="${apiKey}"></div>
    <div class="investi-market-data-field-name">${this.translate('Prev Close:', locale)} </div>
    <div class="investi-share-price-prevClose" apiKey="${apiKey}" ${dpAttr}></div>

    <div class="investi-market-data-field-name">${this.translate('Low:', locale)} </div>
    <div class="investi-share-price-low" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">${this.translate('52 Week Low:', locale)} </div>
    <div class="investi-share-price-low52Week" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">${this.translate('High:', locale)} </div>
    <div class="investi-share-price-high" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">${this.translate('52 Week High:', locale)} </div>
    <div class="investi-share-price-high52Week" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">${this.translate('Ask:', locale)} </div>
    <div class="investi-share-price-ask" apiKey="${apiKey}" ${dpAttr}></div>

    <div class="investi-market-data-field-name">${this.translate('Open:', locale)} </div>
    <div class="investi-share-price-open" apiKey="${apiKey}" ${dpAttr}></div>

    <div class="investi-market-data-field-name">${this.translate('Bid:', locale)} </div>
    <div class="investi-share-price-bid" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">${this.translate('Updated:', locale)}</div>
    <div class="investi-share-price-updated" apiKey="${apiKey}"></div>

  </div>

  <div class="investi-market-data-delayed-info">${this.translate('Market Data prices are at least 20 minutes delayed', locale)}</div>


  `

  }

  getChartData(apiKey:string|null, callback:(wrapper:IApiKeyWrapper)=>void) {
    const container = this.ensureContainer(apiKey);
    const handler = () => {
      callback(container);
    }
    if (!container.chartData) {
      this.sendRequest('/api/chartdata', apiKey,
        json => {
          this.setContainerField(container, json, x =>container.chartData = x)
          handler();
        });
    } else {
      handler();
    }
  }

  createChart(elem:HTMLElement, container:IApiKeyWrapper){
    if(this.checkSubscriptionExpired(elem, container))
      return;
    const data:StockData[] = container.chartData;
      var color:string = elem.getAttribute('data-investi-chart-theme-color-hex');
      var yAxisColor:string = elem.getAttribute('data-investi-chart-theme-yAxisColor-hex');
      var xAxisColor:string = elem.getAttribute('data-investi-chart-theme-xAxisColor-hex');
      var rangeSelected:string = elem.getAttribute('data-investi-chart-range-selected');
      const showChartHeader:boolean = elem.getAttribute('data-investi-chart-header')?.toLowerCase() === "true";
      const numDecimalPlacesAttr = elem.getAttribute('investi-num-decimal-places');
      const numDecimalPlaces = numDecimalPlacesAttr ? +numDecimalPlacesAttr : undefined;
      const locale = this.getLocale(elem);
      const customColors: ChartCustomColors = {
        priceGradientStart: elem.getAttribute('data-investi-chart-price-gradient-start-hex') || undefined,
        priceGradientEnd:   elem.getAttribute('data-investi-chart-price-gradient-end-hex')   || undefined,
        volumeColor:        elem.getAttribute('data-investi-chart-volume-color-hex')         || undefined,
        zoomButtonBg:       elem.getAttribute('data-investi-chart-zoom-button-bg-hex')       || undefined,
        zoomButtonText:     elem.getAttribute('data-investi-chart-zoom-button-text-hex')     || undefined,
        zoomButtonActiveBg: elem.getAttribute('data-investi-chart-zoom-button-active-bg-hex')|| undefined,
      };

      this.waitForECharts(10, 200)
    .then(() => {
      this.makeChart(elem, data, container.marketData, color, yAxisColor, xAxisColor, parseInt(rangeSelected),showChartHeader, numDecimalPlaces, locale, customColors);
    })
    .catch((error) => {
        console.error(error);
        // Handle the error (e.g., display a user-friendly message)
    });

  }

  waitForECharts(maxAttempts:number, interval:number) {
    return new Promise<void>((resolve, reject) => {
        if (typeof echarts !== "undefined") {
            resolve();
            return;
        }

        const url = "https://cdn.jsdelivr.net/npm/echarts@5.6.0/dist/echarts.min.js";
        let attemptBudget = maxAttempts;

        if (!document.querySelector('script[data-investi-echarts]')) {
            const script = document.createElement('script');
            script.src = url;
            script.async = true;
            script.integrity = InvestiWidget.CdnIntegrity[url];
            script.crossOrigin = 'anonymous';
            script.setAttribute('data-investi-echarts', 'true');
            script.onerror = () => reject(new Error("Failed to load " + url));
            document.head.appendChild(script);
            attemptBudget = Math.max(maxAttempts, Math.ceil(30000 / interval));
        }

        let attempts = 0;
        const checkECharts = () => {
            if (typeof echarts !== "undefined") {
                resolve();
            } else if (attempts < attemptBudget) {
                attempts++;
                setTimeout(checkECharts, interval);
            } else {
                reject(new Error("echarts failed to load from " + url + " within " + (attemptBudget * interval) + "ms"));
            }
        };

        checkECharts();
    });
}


  getChartRangeSelectorButtons(attrVal:string) : {text:string, type:string, count?:number}[] {


    const parts = attrVal.split(',');
    const buttons = parts.map(part => {
      const text = part;
      let type: string, count: number | undefined;

      if (part === 'YTD') {
          type = 'ytd';
      } else if (part === 'All') {
          type = 'all';
      } else {
          const match = part.match(/(\d+)([a-z]+)/);
          if (match) {
              count = parseInt(match[1], 10);
              const unit = match[2];
              if (unit === 'm') {
                  type = 'month';
              } else if (unit === 'y') {
                  type = 'year';
              }
          }
      }

      return { type, count, text };
    });
    return buttons;
  }

  computeRangeBounds(button:{type:string, count?:number}, categoryTimestamps:number[]) : { startValue:number, endValue:number } | null {
    if (!categoryTimestamps.length) return null;
    const lastIdx = categoryTimestamps.length - 1;
    const endTs = categoryTimestamps[lastIdx];
    let startTs: number;
    if (button.type === 'all') {
      return { startValue: 0, endValue: lastIdx };
    } else if (button.type === 'ytd') {
      const end = new Date(endTs);
      startTs = Date.UTC(end.getUTCFullYear(), 0, 1);
    } else if (button.type === 'month' && button.count) {
      const d = new Date(endTs);
      d.setUTCMonth(d.getUTCMonth() - button.count);
      startTs = d.getTime();
    } else if (button.type === 'year' && button.count) {
      const d = new Date(endTs);
      d.setUTCFullYear(d.getUTCFullYear() - button.count);
      startTs = d.getTime();
    } else {
      return null;
    }
    let startIdx = 0;
    for (let i = 0; i < categoryTimestamps.length; i += 1) {
      if (categoryTimestamps[i] >= startTs) { startIdx = i; break; }
    }
    return { startValue: startIdx, endValue: lastIdx };
  }

  hexToRgba(hex:string, alpha:number) : string {
    let h = (hex || '#000000').replace('#', '');
    if (h.length === 3) h = h.split('').map(c => c + c).join('');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  makeChart(elem:HTMLElement, data:StockData[], marketData:StockMarketData, color:string, yAxisColor?:string, xAxisColor?:string, rangeSelected?:number, showChartHeader?:boolean, numDecimalPlaces?:number|undefined, locale?:string|undefined, customColors?:ChartCustomColors) {

    const buttonsAttrRaw = elem.getAttribute('data-investi-range-selector-buttons');
    const buttonsAttr = buttonsAttrRaw || '1m,3m,6m,YTD,1y,All';
    const ticker = `${marketData?.ticker}:${marketData?.exchange}`

    const containerElem = elem;
    containerElem.classList.remove(SharePriceChartWidgetName);
    containerElem.classList.add("investi-share-price-chart-container");

    if (showChartHeader) {
      const headerDiv = document.createElement('div');
      headerDiv.className = "investi-share-price-chart-header";
      this.setChartHeaderElem(headerDiv, marketData, numDecimalPlaces, locale);
      containerElem.appendChild(headerDiv);
    }

    const buttons = this.getChartRangeSelectorButtons(buttonsAttr);

    const buttonRow = document.createElement('div');
    buttonRow.className = 'investi-share-price-chart-range-buttons';
    buttonRow.style.cssText = 'display:flex;align-items:center;gap:6px;padding:4px 0;flex-wrap:wrap;';
    const zoomLabel = document.createElement('span');
    zoomLabel.textContent = 'Zoom';
    zoomLabel.style.cssText = 'color:#666;font-size:0.85em;margin-right:6px;';
    buttonRow.appendChild(zoomLabel);
    containerElem.appendChild(buttonRow);

    const chartElem = document.createElement('div');
    chartElem.classList.add(SharePriceChartWidgetName);
    if (!chartElem.style.height) {
      chartElem.style.height = '400px';
    }
    containerElem.appendChild(chartElem);
    const { option, categoryTimestamps } = this.getChartOptions(data, color, ticker, yAxisColor, xAxisColor, rangeSelected, buttonsAttr, numDecimalPlaces, locale, customColors);

    const btnBg = customColors?.zoomButtonBg || '#f7f7f7';
    const btnText = customColors?.zoomButtonText || '#333';
    const btnActiveBg = customColors?.zoomButtonActiveBg || this.hexToRgba(color || '#000', 0.1);

    const instance = echarts.init(chartElem, null, { renderer: 'svg' });
    instance.setOption(option);

    const selectedIndex = (rangeSelected === undefined || isNaN(rangeSelected)) ? Math.max(0, buttons.length - 2) : rangeSelected;
    const buttonElems: HTMLButtonElement[] = [];
    const applyButton = (idx:number) => {
      const btn = buttons[idx];
      const bounds = this.computeRangeBounds(btn, categoryTimestamps);
      if (!bounds) return;
      instance.dispatchAction({
        type: 'dataZoom',
        startValue: bounds.startValue,
        endValue: bounds.endValue
      });
      buttonElems.forEach((b, i) => {
        b.style.fontWeight = i === idx ? 'bold' : 'normal';
        b.style.color = i === idx ? (color || '#000') : btnText;
        b.style.background = i === idx ? btnActiveBg : btnBg;
      });
    };

    buttons.forEach((b, idx) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = b.text;
      btn.style.cssText = `min-width:40px;padding:3px 8px;font-size:12px;border:0;border-radius:2px;background:${btnBg};color:${btnText};cursor:pointer;`;
      btn.addEventListener('click', () => applyButton(idx));
      buttonRow.appendChild(btn);
      buttonElems.push(btn);
    });

    if (buttons[selectedIndex]) {
      applyButton(selectedIndex);
    }

    const resize = () => instance.resize();
    window.addEventListener('resize', resize);
  }

  getChartOptions(data:StockData[], color:string, ticker:string, yAxisColor?:string, xAxisColor?:string, rangeSelected?:number, buttonsAttr?:any, numDecimalPlaces?:number|undefined, locale?:string|undefined, customColors?:ChartCustomColors) : { option:any, categories:string[], categoryTimestamps:number[] } {

    const defaultColor = color || '#000000';
    const defaultAxisColor = '#D3D3D3';
    const defaultAxisTextColor = '#000';
    const axisLineColor = xAxisColor || defaultAxisColor;
    const yLineColor = yAxisColor || defaultAxisColor;
    const xLabelColor = xAxisColor || defaultAxisTextColor;
    const yLabelColor = yAxisColor || defaultAxisTextColor;

    const categories: string[] = [];
    const categoryTimestamps: number[] = [];
    const priceSeries: number[] = [];
    const volumeSeries: number[] = [];
    const dataLength = data.length;
    const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    for (let i = 0; i < dataLength; i += 1) {
      const isoDate = data[i].date.substring(0, 10);
      const jsDate = new Date(isoDate);
      let close = data[i].close;
      if (numDecimalPlaces != undefined){
        close = +close.toFixed(numDecimalPlaces);
      }
      categories.push(isoDate);
      categoryTimestamps.push(Math.round(jsDate.getTime()));
      priceSeries.push(close);
      volumeSeries.push(data[i].volume);
    }

    const priceName = this.translate('Price', locale);
    const volumeName = this.translate('Volume:', locale).replace(':', '');
    const echartsLocale = this.getEChartsLocale(locale);
    const compactNumber = (v:number) : string => {
      const abs = Math.abs(v);
      if (abs >= 1e9) return +(v / 1e9).toFixed(1) + 'B';
      if (abs >= 1e6) return +(v / 1e6).toFixed(0) + 'M';
      if (abs >= 1e3) return +(v / 1e3).toFixed(0) + 'k';
      return String(v);
    };
    const formatCategoryLabel = (iso:string) : string => {
      // iso = "YYYY-MM-DD" → "D Mon"
      const parts = iso.split('-');
      if (parts.length !== 3) return iso;
      const d = parseInt(parts[2], 10);
      const m = parseInt(parts[1], 10);
      return `${d} ${shortMonths[m - 1] || ''}`;
    };

    const option = {
      textStyle: { fontFamily: 'Segoe UI, Roboto, sans-serif', fontSize: 13 },
      backgroundColor: 'transparent',
      animation: false,
      title: { show: false },
      legend: { show: false },
      grid: [
        { left: 20, right: 60, top: 30, height: '55%', containLabel: false },
        { left: 20, right: 60, top: '69%', height: '23%', containLabel: false }
      ],
      axisPointer: {
        link: [{ xAxisIndex: 'all' }],
        lineStyle: { color: defaultColor, type: 'dotted' },
        label: { backgroundColor: defaultColor }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'cross', crossStyle: { color: defaultColor }, lineStyle: { color: defaultColor } },
        formatter: (params:any[]) => {
          if (!params || !params.length) return '';
          const isoDate = params[0].axisValue || params[0].name || '';
          const rows = params.map(p => {
            const v = p.value;
            const formatted = p.seriesName === volumeName
              ? Number(v).toLocaleString()
              : (numDecimalPlaces != undefined ? Number(v).toFixed(numDecimalPlaces) : v);
            return `<div style="display:flex;justify-content:space-between;gap:12px;"><span>${p.marker} ${p.seriesName}</span><b>${formatted}</b></div>`;
          }).join('');
          return `<div style="font-weight:bold;margin-bottom:4px;">${isoDate}</div>${rows}`;
        }
      },
      xAxis: [
        {
          type: 'category',
          gridIndex: 0,
          data: categories,
          boundaryGap: true,
          axisLine: { lineStyle: { color: axisLineColor } },
          axisTick: { show: true, lineStyle: { color: axisLineColor } },
          axisLabel: { show: false },
          splitLine: { show: true, lineStyle: { color: '#D3D3D3', type: 'dashed' } }
        },
        {
          type: 'category',
          gridIndex: 1,
          data: categories,
          boundaryGap: true,
          axisLine: { lineStyle: { color: axisLineColor } },
          axisTick: { lineStyle: { color: axisLineColor } },
          axisLabel: { color: xLabelColor, hideOverlap: true, formatter: formatCategoryLabel },
          splitLine: { show: true, lineStyle: { color: '#D3D3D3', type: 'dashed' } }
        }
      ],
      yAxis: [
        {
          type: 'value',
          gridIndex: 0,
          position: 'right',
          scale: true,
          name: priceName,
          nameLocation: 'middle',
          nameGap: 40,
          nameRotate: 90,
          nameTextStyle: { color: yLabelColor, fontSize: 12 },
          axisLine: { show: false, lineStyle: { color: yLineColor } },
          axisTick: { show: false },
          axisLabel: { color: yLabelColor },
          splitLine: { show: true, lineStyle: { color: '#D3D3D3', type: 'dashed' } }
        },
        {
          type: 'value',
          gridIndex: 1,
          position: 'right',
          scale: false,
          splitNumber: 2,
          min: 0,
          name: volumeName,
          nameLocation: 'middle',
          nameGap: 40,
          nameRotate: 90,
          nameTextStyle: { color: yLabelColor, fontSize: 12 },
          axisLine: { show: false, lineStyle: { color: yLineColor } },
          axisTick: { show: false },
          axisLabel: { color: yLabelColor, formatter: compactNumber },
          splitLine: { show: false }
        }
      ],
      dataZoom: [
        { type: 'inside', xAxisIndex: [0, 1] },
        { type: 'slider', xAxisIndex: [0, 1], show: true, bottom: 0, height: 12, showDetail: false }
      ],
      series: [
        {
          name: ticker,
          type: 'line',
          xAxisIndex: 0,
          yAxisIndex: 0,
          showSymbol: false,
          symbol: 'circle',
          symbolSize: 8,
          large: false,
          progressive: 0,
          lineStyle: { color: defaultColor, width: 1 },
          itemStyle: { color: defaultColor },
          emphasis: { focus: 'series', lineStyle: { width: 2 } },
          areaStyle: {
            color: customColors?.priceGradientStart && customColors?.priceGradientEnd
              ? new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: customColors.priceGradientStart },
                  { offset: 1, color: customColors.priceGradientEnd }
                ])
              : this.hexToRgba(defaultColor, 0.3)
          },
          data: priceSeries
        },
        {
          name: volumeName,
          type: 'bar',
          xAxisIndex: 1,
          yAxisIndex: 1,
          large: false,
          progressive: 0,
          itemStyle: { color: customColors?.volumeColor || this.hexToRgba(defaultColor, 0.5) },
          data: volumeSeries
        }
      ],
      ...(echartsLocale ? { useUTC: false, locale: echartsLocale } : {})
    };

    return { option, categories, categoryTimestamps };
  }

  setChartHeaderElem(headerDiv:HTMLElement, marketData:StockMarketData, numDecimalPlaces?:number|undefined, locale?:string|undefined){

    const companyNameRow = document.createElement('div');
    companyNameRow.className = "investi-share-price-chart-header-company-name-row";

    const companyNameDiv = document.createElement('span');
    companyNameDiv.className = "investi-share-price-chart-header-company-name";
    companyNameDiv.innerText = marketData.companyName;

    const companyTickerDiv = document.createElement('span');
    companyTickerDiv.className = "investi-share-price-chart-header-company-ticker";

    companyTickerDiv.innerText = `(${marketData.ticker})`;
    companyNameRow.appendChild(companyNameDiv);
    companyNameRow.appendChild(companyTickerDiv);
    headerDiv.append(companyNameRow);


    const priceDivRow = document.createElement('div');
    priceDivRow.className = "investi-share-price-chart-header-price-row";

    let priceSpan = document.createElement('span');
    priceSpan.className = "investi-share-price-chart-header-last-price-elem";
    if(numDecimalPlaces){
      priceSpan.setAttribute('investi-num-decimal-places', numDecimalPlaces+'')
    }

    this.setPriceWidgetLastPriceDiv(priceSpan, this.addZeroes(marketData.last, priceSpan), marketData.currency);
    priceDivRow.append(priceSpan);

    const movementDiv = document.createElement('span');
    if(numDecimalPlaces){
      movementDiv.setAttribute('investi-num-decimal-places', numDecimalPlaces+'')
    }
    this.setSharePriceMovement(movementDiv, marketData);
    movementDiv.classList.add("investi-share-price-chart-header-movement-elem")

    priceDivRow.append(movementDiv);

    const movementPercentDiv = document.createElement('span');
      if(numDecimalPlaces){
      movementPercentDiv.setAttribute('investi-num-decimal-places', numDecimalPlaces+'')
    }
    this.setSharePriceMovementPercent(movementPercentDiv, marketData.movementPercent);
    movementPercentDiv.classList.add("investi-share-price-chart-header-movement-percent-elem")
    priceDivRow.append(movementPercentDiv);

    const exchangeDiv = document.createElement('span');
    exchangeDiv.className = "investi-share-price-chart-header-exchange";

    const separatorElem = document.createElement('span');
    separatorElem.className = "investi-share-price-chart-header-exchange-separator";
    separatorElem.innerText = "  | ";
    exchangeDiv.append(separatorElem);

    const exchangeNameDiv = document.createElement('span');
    exchangeNameDiv.className = "investi-share-price-chart-header-exchange-name";
    exchangeNameDiv.innerText = marketData.exchange;
    exchangeDiv.append(exchangeNameDiv);

    const exchangeNameSuffixDiv = document.createElement('span');
    exchangeNameSuffixDiv.className = "investi-share-price-chart-header-exchange-suffix";
    exchangeNameSuffixDiv.innerText = " " + this.translate('Exchange', locale);
    exchangeDiv.append(exchangeNameSuffixDiv);

    priceDivRow.append(exchangeDiv);

    headerDiv.append(priceDivRow)
    // this.createPriceWidget(elems, marketData, true);



  }

  createInvestiAnnouncementTable() {

    this.doActionOnIdOrClass(AnnouncementsWidgetName, (elem, apiKey) => {

      this.getAnnouncementData(apiKey, container => {
        let announcements = container.announcements;
        if(this.checkSubscriptionExpired(elem, container))
          return;
        elem.innerHTML = '';
        const options = new AnnouncementTableOptions();
        options.announcementDateFormat = this.getDateFormat(elem);
        options.announcementLocale = this.getLocale(elem);
        options.hidePriceSensitive = elem.getAttribute('data-invest-hide-price-sensitive')==='true';
        if (elem.getAttribute('data-investi-num-announcements')){
          options.numAnnouncements = parseInt(elem.getAttribute('data-investi-num-announcements'));
        }

        announcements = this.filterAnnouncements(elem, announcements);
        this.setAnnouncementData(elem, announcements, options);
      });
    });
  }

  getDateFormat(elem:HTMLElement):string|undefined {
    return elem.getAttribute('data-investi-announcement-date-format') || elem.getAttribute('data-investi-date-format');
  }
  getLocale(elem:HTMLElement):string|undefined {
    return elem.getAttribute('data-investi-locale');
  }

  getTranslations(locale:string|undefined) {
    const translations = {
      'pl_PL': {
        'Symbol:': 'Symbol:',
        'Share Price:': 'Cena akcji:',
        'Market Cap:': 'Kapitalizacja:',
        'Shares on Issue:': 'Akcje w obiegu:',
        '% Change:': '% Zmiana:',
        'Change:': 'Zmiana:',
        'Volume:': 'Wolumen:',
        'Prev Close:': 'Poprzednie zamknięcie:',
        'Low:': 'Najniższa:',
        '52 Week Low:': 'Najniższa 52 tyg:',
        'High:': 'Najwyższa:',
        '52 Week High:': 'Najwyższa 52 tyg:',
        'Ask:': 'Cena sprzedaży:',
        'Open:': 'Otwarcie:',
        'Bid:': 'Cena kupna:',
        'Updated:': 'Zaktualizowano:',
        'Market Data prices are at least 20 minutes delayed': 'Dane rynkowe są opóźnione o co najmniej 20 minut',
        'Price': 'Cena',
        'Exchange': 'Giełda',
        'Search...': 'Szukaj...',
        '-- Prior Year --': '-- Poprzedni rok --',
        'Filter by Year:': 'Filtruj według roku:',
        'Prev': 'Poprz.',
        'Next': 'Nast.',
        'Showing': 'Wyświetlanie',
        'of': 'z',
        'No results': 'Brak wyników'
      },
      'de_DE': {
        'Symbol:': 'Symbol:',
        'Share Price:': 'Aktienkurs:',
        'Market Cap:': 'Marktkapitalisierung:',
        'Shares on Issue:': 'Ausstehende Aktien:',
        '% Change:': '% Änderung:',
        'Change:': 'Änderung:',
        'Volume:': 'Volumen:',
        'Prev Close:': 'Vorheriger Schlusskurs:',
        'Low:': 'Tief:',
        '52 Week Low:': '52-Wochen-Tief:',
        'High:': 'Hoch:',
        '52 Week High:': '52-Wochen-Hoch:',
        'Ask:': 'Briefkurs:',
        'Open:': 'Eröffnung:',
        'Bid:': 'Geldkurs:',
        'Updated:': 'Aktualisiert:',
        'Market Data prices are at least 20 minutes delayed': 'Marktdaten sind mindestens 20 Minuten verzögert',
        'Price': 'Preis',
        'Exchange': 'Börse',
        'Search...': 'Suchen...',
        '-- Prior Year --': '-- Vorjahr --',
        'Filter by Year:': 'Nach Jahr filtern:',
        'Prev': 'Zurück',
        'Next': 'Weiter',
        'Showing': 'Anzeige',
        'of': 'von',
        'No results': 'Keine Ergebnisse'
      }
    };
    return translations[locale] || {};
  }

  translate(key:string, locale:string|undefined):string {
    if (!locale) {      
      return key;
    }
    const translations = this.getTranslations(locale);
    return translations[key] || key;
  }

  getEChartsLocale(locale:string|undefined) : string | undefined {
    if (!locale) return undefined;
    const map: { [k:string]: string } = {
      'pl_PL': 'PL',
      'de_DE': 'DE'
    };
    return map[locale];
  }

  readonly InteractiveAnnouncementsRowHiddenClassName:string = 'investi-interactive-announcements-row-hidden';
  readonly InteractiveAnnouncementsHeadlineClassName:string = 'investi-interactive-announcements__headline';
  readonly InteractiveAnnouncementsPerPageDefault:number = 8;

  static readonly ArrowLeftIconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>';
  static readonly CommentIconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>';
  static readonly StoriBotIconSvg = '<svg viewBox="0 0 117 116" fill="none" aria-hidden="true"><path d="M50.1908 104.944L58 113V98.8648C58 97.8066 57.5807 96.7916 56.834 96.0419L51.3724 90.5587C50.8117 89.9958 50.1702 89.5195 49.4692 89.1456L16.9553 71.8043C14.3484 70.4139 12.7201 67.7 12.7201 64.7455V27.7196C12.7201 22.0752 18.4077 18.2058 23.6577 20.2784L58 33.8362V22.652L11.9545 4.35334C6.70198 2.26598 1 6.13574 1 11.7878V38.9435V73.1215C1 76.0578 2.60853 78.7581 5.1905 80.1563L48.2561 103.477C48.9718 103.865 49.6242 104.359 50.1908 104.944Z" fill="#217EF1" stroke="#217EF1" stroke-width="2"/><path d="M67.6611 104.956L60 113V98.8441C60 97.7982 60.4096 96.7939 61.1411 96.0464L66.4999 90.5704C67.0583 89.9998 67.6991 89.5159 68.4008 89.135L100.302 71.8164C102.88 70.4169 104.486 67.7188 104.486 64.7856V27.7968C104.486 22.1317 98.7593 18.2614 93.5027 20.3737L60 33.8362V22.652L105 4.44945C110.259 2.32218 116 6.19274 116 11.8657V38.9435V73.1618C116 76.0767 114.415 78.7609 111.862 80.168L69.5925 103.467C68.8764 103.861 68.225 104.363 67.6611 104.956Z" fill="#217EF1" stroke="#217EF1" stroke-width="2"/></svg>';


  createInvestiAnnouncementsInteractiveTable() {

    for(const widgetName of [AnnouncementsInteractiveWidgetName, AnnouncementsInteractiveV2WidgetName]){
    this.doActionOnIdOrClass(widgetName, (e, apiKey) => {
      const elem = e as AnnouncementsInteractiveWidgetElement;
      const v2 = widgetName === AnnouncementsInteractiveV2WidgetName;
      if(v2){
        //v1 class added after lookup so all existing css keeps working; v1 creator ran first so it can't re-claim this elem
        elem.classList.add(AnnouncementsInteractiveWidgetName);
      }
      this.getAnnouncementData(apiKey, container => {
        let announcements = container.announcements;
        if(this.checkSubscriptionExpired(elem, container))
          return;
        elem.innerHTML = '';
        const noComments = elem.hasAttribute('data-investi-no-comments');
        const commentsWordingType = this.getCommentsWordingType(elem);
        const numPerPage = +elem.getAttribute('data-investi-announcements-per-page') || this.InteractiveAnnouncementsPerPageDefault;
        const options = new AnnouncementTableOptions();
        options.announcementDateFormat = this.getDateFormat(elem);
        options.announcementLocale = this.getLocale(elem);
        elem.investi = { announcements, page: 0, apiKey: container.apiKey, noComments, commentsWordingType, numPerPage, rowClassName: ".investi-interactive-announcements-row", locale: options.announcementLocale, v2, loginLink: elem.getAttribute('data-investi-login-link') };
        options.hidePriceSensitive = elem.getAttribute('data-invest-hide-price-sensitive')==='true';
        if (elem.getAttribute('data-investi-num-announcements')){
          options.numAnnouncements = parseInt(elem.getAttribute('data-investi-num-announcements'));
        }

        announcements = this.filterAnnouncements(elem, announcements);

        this.setAnnouncementInteractiveTableData(elem, announcements, options);
      });
    });
    }
  }

  getCommentsWordingType(elem:AnnouncementsInteractiveWidgetElement){
    let commentsWordingType:CommentsWordingType = 'comment';
    const wordingAttrVal:string = elem.getAttribute('data-investi-comments-wording');
    if(wordingAttrVal === 'question'){
      commentsWordingType = wordingAttrVal;
    }
    return commentsWordingType;
  }

  getAnnouncementInteractiveNav(data:AnnouncementsInteractiveWidgetData) : HTMLElement{

    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-interactive-announcements-scroll-to-nav';


    if (window.matchMedia("(min-width: 1540px)").matches) {
      return elem;
    }



    const type = data.commentsWordingType;



    if (!window.matchMedia("(min-width: 800px)").matches) {
      const scrollToPdf: HTMLElement = document.createElement('span');
      scrollToPdf.innerHTML = '<a href="#investi-pdf-container">View PDF</a>';
      scrollToPdf.className = 'investi-interactive-announcements-scroll-to-pdf';
      elem.appendChild(scrollToPdf);
    }


    if(!data.noComments){
      const scrollToAsk: HTMLElement = document.createElement('span');
      const wording = type === 'question' ? 'Ask a Question' : 'Add a comment';
      scrollToAsk.innerHTML = `<a href="#investi-add-comment-container">${wording}</a>`;
      scrollToAsk.className = 'investi-interactive-announcements-scroll-to-add-comment';
      elem.appendChild(scrollToAsk);
    }
    if(elem.childNodes.length){
      const label: HTMLElement = document.createElement('span');
      label.innerText = "Scroll to:";
      label.className = 'investi-interactive-announcements-scroll-to-nav-label';
      elem.prepend(label);
    }



    return elem;
  }

  async setAnnouncementInteractiveTableData(elem: AnnouncementsInteractiveWidgetElement, announcements:Announcement[], options: AnnouncementTableOptions) {

    const container: HTMLElement = document.createElement('div');
    container.className = 'investi-interactive-announcements-table-container'
    elem.appendChild(container);


    if(!elem.investi.v2){ //v2 has no scroll-to nav; its anchors would target elements hidden in list view
      container.appendChild(this.getAnnouncementInteractiveNav(elem.investi));
    }


    const header: HTMLElement = document.createElement('div');
    header.className = 'investi-interactive-announcements-header'
    const headerTitleText = elem.getAttribute('data-investi-announcement-header-title') || '';
    if(headerTitleText){
      const headerTitle: HTMLElement = document.createElement('div');
      headerTitle.innerText = headerTitleText;
      header.appendChild(headerTitle)
    }

    container.appendChild(header);

    const tableElem: HTMLElement = document.createElement('table');
    const tableBody: HTMLElement = document.createElement('tbody');
    tableElem.appendChild(tableBody);

    container.appendChild(tableElem);
    const numAnnouncements = options.numAnnouncements || announcements.length;
    const show = Math.min(numAnnouncements, announcements.length);
    const rows:HTMLElement[] = [];

    for (let i = 0; i < show; i++) {
      const announcement = announcements[i];
      const trElem: HTMLElement = document.createElement('tr');
      const tdDate: HTMLElement = document.createElement('td');
      tdDate.className = 'investi-interactive-announcements__date';

      tdDate.innerHTML = this.getAnnouncementDate(options.announcementDateFormat, announcement, options.announcementLocale)
      let tdHeadline: HTMLElement = document.createElement('td')
      tdHeadline.className = this.InteractiveAnnouncementsHeadlineClassName;
      let spanHeadline: HTMLElement = document.createElement(elem.investi.v2 ? 'a' : 'span')
      spanHeadline.innerText = announcement.headline;
      if(elem.investi.v2){
        //real href so hover shows the url and ctrl/cmd/middle-click opens a new tab; a plain click opens it in place via the td
        (spanHeadline as HTMLAnchorElement).href = this.getAnnouncementDetailHref(elem, announcement);
        spanHeadline.onclick = e => {
          if(e.ctrlKey || e.metaKey || e.shiftKey){
            e.stopPropagation();
            return;
          }
          e.preventDefault();
        };
      }


      const storiBot = elem.investi.v2 && announcement.storiBotUrl;
      tdHeadline.onclick = () => { this.onAnnouncementSelected(elem, trElem, announcement)
        trElem.classList.add('investi-interactive-announcements-row-selected');
      };
      tdHeadline.append(spanHeadline);
      if(storiBot){
        const logo: HTMLElement = document.createElement('span');
        logo.className = 'investi-v2-storibot-logo';
        logo.title = 'StoriBot';
        logo.innerHTML = InvestiWidget.StoriBotIconSvg;
        tdHeadline.append(logo);
      }

      let tdComments: HTMLElement = document.createElement('td');
      if(elem.investi.v2){
        tdComments.className = 'investi-v2-row-meta';
        tdComments.innerHTML =
          `<span class="investi-v2-meta investi-v2-meta-views">${announcement.hits ?? 0} views</span>` +
          `<span class="investi-v2-meta" title="Comments">${InvestiWidget.CommentIconSvg}${announcement.numComments ?? 0}</span>`;
      }
      else if(announcement.numComments){

        let commentsSpan: HTMLElement = document.createElement('span')
        commentsSpan.className = 'investi-icon investi-icon-comment investi-interactive-announcements__comments';
        commentsSpan.innerText = `${announcement.numComments}` ;
        tdComments.append(commentsSpan);
      }


      trElem.appendChild(tdDate);
      trElem.appendChild(tdHeadline);
      trElem.appendChild(tdComments);
      trElem.className = `investi-interactive-announcements-row ${this.InteractiveAnnouncementsRowHiddenClassName}`;

      tableBody.appendChild(trElem);

      rows.push(trElem)
    }



    if(elem.investi.v2){
      //v2: searchbox on the left of the header, pagination below the table
      if(elem.hasAttribute('data-investi-searchbox')){
        header.append(this.createSearchBox(rows, { onkeyup: this.searchBox_onkeyup(), locale: options.announcementLocale }));
      }
      container.append(this.getPaginationElement(elem, elem.investi));
    }else{
      header.append(this.getPaginationElement(elem, elem.investi))

      if(elem.hasAttribute('data-investi-searchbox')){
        header.append(this.createSearchBox(rows, { onkeyup: this.searchBox_onkeyup(), locale: options.announcementLocale }));
      }
    }

    this.setAnnouncementTableRowsVisible(elem, elem.investi);

    if(elem.investi.v2){
      const openFromUrl = () => this.selectAnnouncementFromUrl(elem, announcements, rows);
      this.addDetailBackButton(elem, openFromUrl, () => {
        if(this.isMobile()){
          container.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }
    elem.append(this.getPdfViewer(elem.investi));

    await this.addPdfJsScript();

    elem.investi.pdfViewer = new PdfViewer(elem);


    if(!elem.investi.noComments){
      const commentsContainer: HTMLElement = document.createElement('div');
      commentsContainer.className = 'investi-comments-container';

      if(elem.investi.v2){
        //v2 requires login to post; identity comes from the auth cookie, not name/email fields
        try{
          elem.investi.me = await this.httpCall<{loggedIn:boolean, name?:string, email?:string}>('GET', `${this.authBaseAddress}/api/auth/me`, null, true);
        }catch(e){
          elem.investi.me = { loggedIn: false };
        }
        //v2: existing questions go below the ask-a-question card
        elem.append(this.getAddCommentsElem(elem.investi.commentsWordingType, elem.investi), commentsContainer);
      }else{
        elem.append(commentsContainer, this.getAddCommentsElem(elem.investi.commentsWordingType, elem.investi));
      }
    }

    if(rows.length && !elem.investi.v2){ //v2 starts in list view; auto-selecting would jump straight to detail
      rows[0].querySelector<HTMLElement>(`.${this.InteractiveAnnouncementsHeadlineClassName}`).click();
    }
    if(elem.investi.v2){
      this.selectAnnouncementFromUrl(elem, announcements, rows); //deep link, e.g. returning from the login page
    }

  }

  //detail view's Back button (own grid row above the pdf container) + browser back/forward.
  //openFromUrl opens the url's announcement (false if it names none); onShowList runs after the list is back
  addDetailBackButton(elem:IWidgetElement<IDetailViewData>, openFromUrl:()=>boolean, onShowList:()=>void){
    const backButton: HTMLElement = document.createElement('button');
    backButton.className = 'investi-v2-back-button';
    backButton.innerHTML = `${InvestiWidget.ArrowLeftIconSvg}<span>Back to announcements</span>`;
    const showList = () => {
      elem.classList.remove(ShowingDetailClassName); //selection/pdf state kept
      elem.querySelector<HTMLIFrameElement>('.investi-storibot-frame')?.setAttribute('src', 'about:blank'); //stop any playback
      onShowList();
    };
    backButton.onclick = () => {
      if(elem.hasAttribute('data-investi-from-tab')){ //the list is the tabs widget on the parent page (this page minus the slug, or the dedicated-page value)
        window.location.href = `${this.getDedicatedPagePath(elem)}/${window.location.search}`;
        return;
      }
      if(history.state?.investiFromList){
        history.back(); //popstate shows the list
        return;
      }
      //landed directly on a detail url: no list entry to go back to
      history.replaceState(null, '', `${this.getDedicatedPagePath(elem)}/${window.location.search}`);
      showList();
    };
    window.addEventListener('popstate', () => {
      if(!openFromUrl()){
        showList();
      }
    });
    elem.append(backButton);
  }

  //switches to the detail view, gives it its own url ({page}/{slug}-asx-{id}) and shows the storibot or pdf
  showAnnouncementDetail(elem:IWidgetElement<IDetailViewData>, announcement:Announcement){
    const storiBot = !!announcement.storiBotUrl;
    elem.classList.add(ShowingDetailClassName); //before setPdf/scrollIntoView so the pdf container is visible
    elem.classList.toggle('investi-v2-storibot-detail', storiBot); //storibot iframe takes the pdf viewer's slot
    //deep link, also the return target after login. Already on this url (deep link/popstate): don't add a history entry
    if(announcement.localPath?.startsWith('/api/') && !window.location.pathname.replace(/\/$/, '').endsWith(`-${this.getAnnouncementId(announcement)}`)){
      history.pushState({ investiFromList: true }, '', `${this.getAnnouncementDetailHref(elem, announcement)}${window.location.search}`);
      this.sendPageView();
    }
    if(!storiBot){
      elem.investi.pdfViewer.setPdf(announcement, this.getAnnouncementHref(announcement));
      return;
    }
    let iframe = elem.querySelector<HTMLIFrameElement>('.investi-storibot-frame');
    if(!iframe){
      iframe = document.createElement('iframe');
      iframe.className = 'investi-storibot-frame';
      iframe.setAttribute('allow', 'autoplay; fullscreen; clipboard-write');
      elem.append(iframe);
    }
    if(iframe.src !== announcement.storiBotUrl)
      iframe.src = announcement.storiBotUrl;
  }

  //opens the announcement named by /announcements/{slug}-{id}; false if the url names none
  selectAnnouncementFromUrl(elem:AnnouncementsInteractiveWidgetElement, announcements:Announcement[], rows:HTMLElement[]): boolean {
    const index = this.getAnnouncementIndexFromUrl(announcements);
    if(index < 0 || index >= rows.length)
      return false;
    elem.investi.page = Math.floor(index / elem.investi.numPerPage); //so the row is visible after Back
    this.setAnnouncementTableRowsVisible(elem, elem.investi);
    rows[index].querySelector<HTMLElement>(`.${this.InteractiveAnnouncementsHeadlineClassName}`).click();
    return true;
  }

  //dedicated-page: rows link to {page}/{slug}-asx-{id} instead of the pdf
  setDedicatedPageLink(widgetElem:HTMLElement, row:HTMLElement, announcement:Announcement){
    if(!widgetElem.hasAttribute('data-investi-dedicated-page') || !announcement.localPath?.startsWith('/api/'))
      return; //remote-hosted (non-ASX): keep the raw remote url
    const link = row.querySelector<HTMLAnchorElement>('a');
    link.href = this.getAnnouncementDetailHref(widgetElem, announcement);
    link.removeAttribute('target');
  }

  //"asx-" marks the segment so the WP plugin can route it under any page path
  getAnnouncementSlugPath(announcement:Announcement): string {
    const id = this.getAnnouncementId(announcement);
    const slug = (announcement.headline || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').substring(0, 60).replace(/^-+|-+$/g, '');
    return slug.length > 0 ? `${slug}-asx-${id}` : `asx-${id}`;
  }

  getAnnouncementIndexFromUrl(announcements:Announcement[], pathname:string = window.location.pathname): number {
    const lastSegment = pathname.replace(/\/$/, '').split('/').pop();
    return announcements.findIndex(a => `-${lastSegment}`.endsWith(`-${this.getAnnouncementId(a)}`));
  }

  // page-view beacon: only browsers that have logged in before (cookies are HttpOnly, so localStorage
  // is the best proxy); server drops hits without a valid session cookie, so fire-and-forget
  sendPageView(){
    if(localStorage.getItem(LastLoginStorageKey)){
      // string body goes as text/plain: a CORS-simple request, so no preflight
      navigator.sendBeacon(`${this.authBaseAddress}/api/auth/pageview`, window.location.href);
    }
  }

  async onAnnouncementSelected(elem:AnnouncementsInteractiveWidgetElement, trElem:HTMLElement, announcement:Announcement){
    const storiBot = elem.investi.v2 && announcement.storiBotUrl;
    if(elem.investi.v2){
      this.showAnnouncementDetail(elem, announcement);
    }else{
      elem.investi.pdfViewer.setPdf(announcement, this.getAnnouncementHref(announcement));
    }
    elem.investi.selectedElem?.classList.remove('investi-interactive-announcements-row-selected')
    elem.investi.selectedElem = trElem;
    elem.investi.selected = announcement;
    // trElem.classList.add('investi-interactive-announcements-row-selected');
    if(!elem.investi.noComments){
      elem.querySelector<HTMLElement>(".investi-add-comment-container").style.display = 'block';
      await this.loadComments(elem, announcement);
    }

    if(this.isMobile()){
      const detailElem = elem.querySelector<HTMLElement>(storiBot ? '.investi-storibot-frame' : '.investi-pdf-container');
      detailElem.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  isMobile():boolean {
    return window.innerWidth < 800
  }


  getCommentVideoDiv(announcement:Announcement) : HTMLElement{
    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-comments-video-container';
    // ponytail: page URLs (vimeo.com/{id}) refuse to iframe; rewrite to the player embed form
    const videoUrl = announcement.videoUrl.replace(/^https?:\/\/(www\.)?vimeo\.com\/(\d+).*$/, 'https://player.vimeo.com/video/$2');
    elem.innerHTML = `<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="${videoUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="${announcement.videoDescription}"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>`;

    const description: HTMLElement = document.createElement('div');
    description.className = 'investi-comments-video-description';
    description.innerText = announcement.videoDescription || '';

    elem.appendChild(description);

    return elem;
  }

  async loadComments(elem: AnnouncementsInteractiveWidgetElement, announcement:Announcement){
    const container = elem.querySelector<HTMLElement>(".investi-comments-container");
    container.innerHTML = '';

    const noContent = !announcement.numComments && !announcement.videoUrl//no comments or video - hide div
    container.style.display = noContent ? 'none' : 'block';

    const commentsWordingType:CommentsWordingType = this.getCommentsWordingType(elem);
    const hasAnnouncementAttrName = 'investi-interactive-announcements-announcement-has-comment';
    elem.classList.remove(hasAnnouncementAttrName);

    if(noContent){
      return;
    }

    const headerContainer: HTMLElement = document.createElement('div');
    headerContainer.className = 'investi-comments-container-header';
    container.append(headerContainer);

    if(announcement.videoUrl){
      headerContainer.append(this.getCommentVideoDiv(announcement));
    }

    if(announcement.numComments){
      elem.classList.add(hasAnnouncementAttrName)
      let result:AnnouncementCommentsResult
      try {
        result = await this.httpCall<AnnouncementCommentsResult>('GET', `${this.baseAddress}/api/announcementComment?apiKey=${elem.investi.apiKey}&announcementGuid=${announcement.sendGuid}`, )
      } catch (error) {
        result = { errorMessage:error, comments:[] }
      }
      if(result.errorMessage){
        console.error(result.errorMessage);
      }else{

        const commentCountElemContainer: HTMLElement = document.createElement('div');
        commentCountElemContainer.className = 'investi-comments-count-container'

        const commentCountElem: HTMLElement = document.createElement('h2');
        commentCountElem.className = 'investi-comments-count'
        commentCountElem.innerText = `${result.comments.length} ${capitalizeFirstLetter(commentsWordingType)}${result.comments.length===1?'':'s'}`
        commentCountElemContainer.appendChild(commentCountElem);

        //const postCommentButton = document.createElement('button') as HTMLButtonElement;
        // postCommentButton.className = 'investi-comments-add-comment-button';
         const postCommentLink = document.createElement('a') as HTMLAnchorElement;
        postCommentLink.className = 'investi-comments-add-comment-button investi-comments-add-comment-link'
        postCommentLink.href = '#investi-add-comment-container';
        // postCommentLink.appendChild(postCommentButton);
        postCommentLink.innerText = commentsWordingType === 'question' ? 'Ask Question' : 'Add Comment';
        this.preserveHashScroll(postCommentLink, elem.investi.v2);

        commentCountElemContainer.appendChild(postCommentLink);

        headerContainer.append(commentCountElemContainer);

        for(let comment of result.comments){
          const commentRow: HTMLElement = document.createElement('div');
          commentRow.className = 'investi-comments-row'

          const commentElem: HTMLElement = document.createElement('blockquote');

          commentElem.className = 'investi-comments-comment';

          const commentSpan: HTMLElement = document.createElement('span');
          commentSpan.className = 'investi-comments-comment-text';
          commentSpan.innerText = comment.comment;
          commentElem.append(commentSpan);

          commentElem.prepend(this.getNameElem(comment, 'investi-comments-name-avatar'));
          // commentRow.appendChild(this.getNameAndDateElem(comment, ""))
          commentRow.appendChild(commentElem);
          for(let response of comment.responses){
            commentRow.appendChild(this.getCommentResponseElem(response));
          }
          container.append(commentRow);
        }
      }

    }


  }

  getCommentResponseElem(comment:AnnouncementCommentApi) : HTMLDivElement{
    const elem: HTMLDivElement = document.createElement('div');
    elem.className = 'investi-comments-response-container'

    const commentElem: HTMLElement = document.createElement('blockquote');



    commentElem.className = 'investi-comments-comment'
    commentElem.innerText = comment.comment;

    commentElem.prepend(this.getNameElem(comment, 'investi-comments-name-response-avatar'))
    elem.appendChild(commentElem);
    return elem;
  }

  getNameElem(comment:AnnouncementCommentApi, avatarClassName:string) : HTMLElement {



    const avatarElem: HTMLElement = document.createElement('div');
    avatarElem.className = avatarClassName;

    const nameElem: HTMLElement = document.createElement('div');
    nameElem.className = 'investi-comments-name'
    nameElem.innerText = `${comment.name}`;

    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-comments-avatar-and-name';
    elem.appendChild(avatarElem);
    elem.appendChild(nameElem);

    const nameElemContainer: HTMLElement = document.createElement('div');
    nameElemContainer.className = 'investi-comments-name-container';
    nameElemContainer.appendChild(elem);
    nameElemContainer.appendChild(this.getDateElem(new Date(comment.date)));

    return nameElemContainer;
  }

  getDateElem(date:Date) : HTMLElement{
    const dateElem: HTMLElement = document.createElement('div');
    dateElem.className = 'investi-comments-date'
    const format1 = new simpleDateFormat('dd MMM yyyy', null);
    const format2 = new simpleDateFormat('h:mm a', null);
    dateElem.innerHTML = format1.format(date) + ' at ' + format2.format(date);
    return dateElem;
  }

  getAddCommentsElem(type:CommentsWordingType, widgetData?:AnnouncementsInteractiveWidgetData) : HTMLElement{
    const v2 = widgetData?.v2;
    const loggedIn = widgetData?.me?.loggedIn;
    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-add-comment-container';
    elem.id = 'investi-add-comment-container'; //a href to this
    elem.style.display = 'none';

    const header: HTMLElement = document.createElement('h2');
    header.className = 'investi-add-comment-header';
    header.innerText = (type=='question'? 'Ask a Question':'Add a Comment') + ' about this announcement';
    elem.appendChild(header);

    const info: HTMLElement = document.createElement('div');
    info.className = 'investi-add-comment-info';
    info.innerText = `All ${type}s are held for moderation. Approved ${type}s will be displayed publicly on this page with the announcement. Your email address will not be published.`;
    elem.appendChild(info);
    const wording = capitalizeFirstLetter(type);
    const requiresLogin = v2 && !loggedIn && widgetData.loginLink; //no point typing a comment you can't send yet
    if(!requiresLogin){
      elem.appendChild(this.getFieldElem(wording, 'textarea', 'investi-add-comment-field-comment-textarea'));
      if(!v2){ //v2: identity comes from the logged-in user
        elem.appendChild(this.getFieldElem('Name', 'text','investi-add-comment-field-name-input'));
        elem.appendChild(this.getFieldElem('Email', 'email','investi-add-comment-field-email-input'));
      }

      elem.appendChild(this.getPrivateCommentCheckbox(type));

      if(!v2){ //v2 posts require login, so no captcha
        const captcha: HTMLDivElement = document.createElement('div');
        captcha.className = 'investi-add-comment-captcha';
        elem.appendChild(captcha);
        this.renderTurnstileWidget(captcha);
      }
    }

    if(v2 && loggedIn){
      const loggedInElem: HTMLDivElement = document.createElement('div');
      loggedInElem.className = 'investi-add-comment-logged-in-as';
      const me = widgetData.me;
      loggedInElem.innerText = `Logged in as ${me.name || me.email}`;
      elem.appendChild(loggedInElem);
    }
    const button: HTMLButtonElement = document.createElement('button');
    if(requiresLogin){
      //not logged in: send to the login page, which sends us back here after login
      button.onclick = () => {
        const sep = widgetData.loginLink.includes('?') ? '&' : '?';
        const returnUrl = window.location.pathname; //site-relative, e.g. /announcements/foo-a48206af-292
        window.location.href = `${widgetData.loginLink}${sep}returnUrl=${encodeURIComponent(returnUrl)}`;
      };
    }else{
      button.onclick = this.postComment.bind(this);
    }
    button.innerText = `Post ${wording}`;
    button.className = 'investi-comments-add-comment-button';
    elem.appendChild(button)

    const submittingElem = this.getLoadingElem()
    submittingElem.classList.add('investi-add-comment-submitting');
    elem.appendChild(submittingElem);


    const successElem: HTMLDivElement = document.createElement('div');
    successElem.className = 'investi-add-comment-success';    
    elem.appendChild(successElem)

    const errorElem: HTMLDivElement = document.createElement('div');
    errorElem.className = 'investi-add-comment-error';
    elem.appendChild(errorElem)

    return elem;
  }

  renderTurnstileWidget(container: HTMLElement) {
    const sitekey = '0x4AAAAAAD9TeWmCXbSa8Xle';
    if (!document.querySelector('script[data-investi-turnstile]')) {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.setAttribute('data-investi-turnstile', 'true');
      document.head.appendChild(script);
    }
    const attempt = (tries: number) => {
      const turnstile = (window as any).turnstile;
      if (turnstile) {
        container.dataset.widgetId = turnstile.render(container, { sitekey: sitekey, appearance: 'interaction-only' });
      } else if (tries > 0) {
        setTimeout(() => attempt(tries - 1), 250);
      }
    };
    attempt(120);
  }

  async postComment(e:MouseEvent) {
    const button = e.target as HTMLButtonElement;
    button.disabled = true;
    const widget = this.getWidget<AnnouncementsInteractiveWidgetElement>(button);
    const parent = this.getParent(e.target, 'investi-add-comment-container');
    const commentElem = parent.querySelector('.investi-add-comment-field-comment-textarea') as HTMLInputElement
    const nameElem = parent.querySelector('.investi-add-comment-field-name-input') as HTMLInputElement
    const emailElem = parent.querySelector('.investi-add-comment-field-email-input') as HTMLInputElement
    const isPrivateCommentElem = parent.querySelector('.investi-add-comment-field-is-private-comment-checkbox') as HTMLInputElement
    const successElem = parent.querySelector('.investi-add-comment-success') as HTMLDivElement
    const errorElem= parent.querySelector('.investi-add-comment-error') as HTMLDivElement
    const submittingElem = parent.querySelector('.investi-add-comment-submitting') as HTMLDivElement

    successElem.style.display = 'none';
    errorElem.style.display = 'none';
    submittingElem.style.display = 'initial';

    const data:AnnouncementCommentRequest= {
      announcementGuid : widget.investi.selected.sendGuid,
      apiKey: widget.investi.apiKey,
      name: nameElem ? nameElem.value : (widget.investi.me?.name || ''),
      isPrivate : isPrivateCommentElem.checked,
      email: emailElem ? emailElem.value : (widget.investi.me?.email || ''),
      comment: commentElem.value,
      // the announcements page, minus the per-announcement slug
      locationHref: `${window.location.origin}${this.getDedicatedPagePath(widget)}/`,
      captchaToken: (parent.querySelector('[name="cf-turnstile-response"]') as HTMLInputElement)?.value || ''
    };

    let result:AnnouncementCommentResult;
    try {
      //v2: identity comes from the login cookie server-side
      const v2 = widget.investi.v2;
      result = await this.httpCall<AnnouncementCommentResult>('POST', `${v2 ? this.authBaseAddress : this.baseAddress}/api/announcementComment${v2 ? '/authenticated' : ''}`, data, v2)
    } catch (error) {
      result = { errorMessage:error }
    }
    submittingElem.style.display = 'none';
    const captchaElem = parent.querySelector('.investi-add-comment-captcha') as HTMLElement;
    (window as any).turnstile?.reset(captchaElem?.dataset.widgetId); // tokens are single-use
    if(result.errorMessage){
      button.disabled = false;
      errorElem.style.display = 'block';
      errorElem.innerText = result.errorMessage;
    }else{
      if(result.message){
        successElem.innerText = result.message;
      }
      successElem.style.display = 'block';
    }


  }

  getParent(child:EventTarget, className:string):HTMLElement{
    let count = 0;
    let parent = (child as HTMLElement).parentElement;
    while(count<20){
      const pageAttr = parent.classList.contains(className)
      if(pageAttr){
        return parent;
      }else{
        parent = parent.parentElement;
        count++;
      }
    }
  }

httpCall<T>(method: string, url: string, data?: any, withCredentials = false): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.withCredentials = withCredentials;

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          resolve(JSON.parse(xhr.responseText) as T);
        } catch (err) {
          reject(`Invalid JSON response: ${(err as Error).message}`);
        }
      } else {
        reject(`${xhr.status} ${xhr.statusText}`);
      }
    };

    xhr.onerror = (e: ProgressEvent<EventTarget>) => {
      // e.target is the xhr itself
      const target = e.target as XMLHttpRequest;
      reject({
        errorMessage: "Network error or connection refused",
        status: target.status,        // usually 0 on network errors
        statusText: target.statusText,
        event: e                      // raw ProgressEvent (can inspect type, timeStamp, etc.)
      });
    };

    xhr.ontimeout = (e: ProgressEvent<EventTarget>) => {
      reject({
        errorMessage: "Request timed out",
        event: e
      });
    };

    xhr.onabort = (e: ProgressEvent<EventTarget>) => {
      reject({
        errorMessage: "Request aborted",
        event: e
      });
    };

    if (data) {
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(JSON.stringify(data));
    } else {
      xhr.send();
    }
  });
}


  httpError(err:string) : string {
    console.error(err);
    return err;
  }

  getPrivateCommentCheckbox(type:CommentsWordingType){
    const field:HTMLElement = document.createElement('p');
    field.className = 'investi-comments-field';
    const label:HTMLElement = document.createElement('label');
    const checkbox:HTMLInputElement = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'investi-add-comment-field-is-private-comment-checkbox';
    label.innerText = `Do not post my ${type} publicly`;
    label.className = 'investi-add-comment-field-is-private-comment-label';
    label.prepend(checkbox);
    field.appendChild(label);
    return field;
  }

  getFieldElem(labelText:string,inputType:InputType, className:string) : HTMLElement{
    const field:HTMLElement = document.createElement('p')
    field.className = 'investi-comments-field';
    const label:HTMLElement = document.createElement('label')
    label.className = 'investi-comments-field-label';
    label.innerText = labelText;
    field.appendChild(label);
    if(inputType === 'textarea'){
      const textarea:HTMLTextAreaElement = document.createElement('textarea');
      textarea.cols  = 45;
      textarea.rows = 8;
      textarea.maxLength = 2000;
      textarea.className = className;
      field.appendChild(textarea);
    }else if(inputType === 'text' || inputType === 'email'){
      const inputElem:HTMLInputElement = document.createElement('input');
      inputElem.type = inputType;
      inputElem.className = className;
      field.appendChild(inputElem);
    }

    return field;
  }

  static readonly PdfJsScriptBase:string = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/5.4.54';
  static readonly PdfJsScriptSrc:string = `${this.PdfJsScriptBase}/pdf.min.mjs`;
  static readonly PdfJsScriptWorker:string = `${this.PdfJsScriptBase}/pdf.worker.min.mjs`;

  // static readonly PdfJsScriptLegacyBase = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@5.4.54/legacy/build';
  // static readonly PdfJsScriptLegacySrc = `${this.PdfJsScriptLegacyBase}/pdf.min.mjs`;
  // static readonly PdfJsScriptLegacyWorker = `${this.PdfJsScriptLegacyBase}/pdf.worker.min.mjs`;

  static readonly PdfJsScriptLegacyBase = 'https://unpkg.com/pdfjs-dist@5.4.54/legacy/build';
  static readonly PdfJsScriptLegacySrc = `${this.PdfJsScriptLegacyBase}/pdf.mjs`;
  static readonly PdfJsScriptLegacyWorker = `${this.PdfJsScriptLegacyBase}/pdf.worker.mjs`;

  // sha384 of each CDN file; regenerate when bumping a version:
  // curl -sL <url> | openssl dgst -sha384 -binary | openssl base64 -A
  static readonly CdnIntegrity: Record<string, string> = {
    'https://cdn.jsdelivr.net/npm/echarts@5.6.0/dist/echarts.min.js': 'sha384-pPi0zxBAoDu6+JXW/C68UZLvBUUtU+7zonhif43rqj7pxsGyqyqzcian2Rj37Rss',
    [this.PdfJsScriptSrc]: 'sha384-L7aWq5iTR9uB6ioydyGLzricd0uYsTbn0iZfCoGmE0oWG4srfVkuqbWiNqtRdEO4',
    [this.PdfJsScriptWorker]: 'sha384-azNj0zE/auAq9Rt4eczZnrQ5fyey8zyacRPhFGOnL7zoxHIPsonfGyYBn/BJxnNK',
    [this.PdfJsScriptLegacySrc]: 'sha384-+RHJplvSpAxbQwwBTbFluysasILpciLmVmO9I7jS2dfENV+HjX38X/Y8aw4m/to2',
    [this.PdfJsScriptLegacyWorker]: 'sha384-3Motlpbo8DatsdazeaA2DNP8Wnq+59zgIsuj4jsDQAslV2T1v42VJV3k90fMAtGt',
  };

  static getPdfJsScriptWork(){
    return this.useLegacy() ? this.PdfJsScriptLegacyWorker : this.PdfJsScriptWorker;
  }

  static getPdfJsScriptSrc(){
    return this.useLegacy() ? this.PdfJsScriptLegacySrc : this.PdfJsScriptSrc;
  }

  static useLegacy(){
    if (typeof (Promise as any).withResolvers === 'undefined'){
      console.log(`withResolvers undefined. will use legacy pdfjs ${this.PdfJsScriptLegacySrc}`);
      return true;
    }
    return false;
  }

  addPdfJsScript(): Promise<void> {
    const urls = [
      InvestiWidget.getPdfJsScriptSrc(),
      InvestiWidget.getPdfJsScriptWork()
    ];

    const loadScript = (src: string): Promise<HTMLScriptElement> => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = src;
        script.integrity = InvestiWidget.CdnIntegrity[src];
        script.crossOrigin = 'anonymous';
        script.onload = () => resolve(script);
        script.onerror = (err) => reject(err);
        document.body.appendChild(script);
      });
    };

    // Start loading both scripts in parallel
    const promises = urls.map(loadScript);

    // Wait for all to resolve
    return Promise.all(promises).then(() => {});
  }

  getPdfAnchorElement(){
    const elem = document.createElement('div');
    elem.className = 'investi-pdf-error-loading';
    const span = document.createElement('span');
    span.innerText = "Error loading PDF"

    elem.append(span);

    return elem;
  }

  getLoadingElem(){
    const loading:HTMLElement = document.createElement('div');
    loading.style.display = 'none';
    loading.className = 'investi-loading'
    loading.innerHTML = '<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>'
    return loading;
  }

  getPdfViewer(data:Pick<AnnouncementsInteractiveWidgetData, 'noComments'|'commentsWordingType'|'v2'>):HTMLElement{
    const commentsWordingType = data.commentsWordingType;
    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-pdf-container';
    elem.id = 'investi-pdf-container'; //mobile nav
    const info:HTMLElement = document.createElement('div');
    info.className = 'investi-pdf-info'
    const infoAnnouncementHeadline:HTMLElement = document.createElement('div');
    infoAnnouncementHeadline.className = 'investi-pdf-info-announcement-headline';
    info.appendChild(infoAnnouncementHeadline);

    elem.append(info);


    elem.append(this.getLoadingElem());
    elem.append(this.getPdfAnchorElement());

    const pdfCanvasHeader = document.createElement('div');
    pdfCanvasHeader.className = 'investi-pdf-canvas-header';
    elem.append(pdfCanvasHeader);

    const buttonsElem = document.createElement('div');
    buttonsElem.className = 'investi-pdf-buttons';
    pdfCanvasHeader.append(buttonsElem);

    const span = document.createElement('span');
    span.innerText = 'PDF Page: '
    const pageNumSpan = document.createElement('span');
    pageNumSpan.className = 'investi-pdf-page-num';
    span.appendChild(pageNumSpan);

    const pageDivider = document.createElement('span');
    pageDivider.innerText = ' / ';
    span.appendChild(pageDivider);

    const pageCountSpan = document.createElement('span');
    pageCountSpan.className = 'investi-pdf-page-count';
    span.appendChild(pageCountSpan);
    buttonsElem.append(span);

    const buttonPrev = document.createElement('button');
    buttonPrev.className = 'investi-pdf-prev-page-btn';
    buttonPrev.innerText = '<<';
    buttonsElem.append(buttonPrev);

    const buttonNext = document.createElement('button');
    buttonNext.className = 'investi-pdf-next-page-btn';
    buttonNext.innerText = '>>';
    buttonsElem.append(buttonNext);

    const pdfLinks = <HTMLDivElement>document.createElement('div');
    pdfLinks.className = 'investi-pdf-links';

    const downloadPdfElem: HTMLAnchorElement = <HTMLAnchorElement>document.createElement('a');
    downloadPdfElem.className = 'investi-pdf-announcement-link'
    downloadPdfElem.target = "_blank";
    downloadPdfElem.innerText = "Download PDF";
    pdfLinks.append(downloadPdfElem);

    if(!data.noComments){
      const addCommentLink: HTMLAnchorElement = <HTMLAnchorElement>document.createElement('a');
      addCommentLink.className = 'investi-add-a-comment-link'
      addCommentLink.href = "#investi-add-comment-container";
      addCommentLink.innerText = commentsWordingType === 'question' ? 'Ask a Question' : 'Add a comment';
      this.preserveHashScroll(addCommentLink, data.v2);
      pdfLinks.append(addCommentLink)
    }


    pdfCanvasHeader.append(pdfLinks);

    const canvas = document.createElement('canvas');
    canvas.className = 'investi-pdf-canvas';
    const textLayer = document.createElement('div');
    textLayer.className = 'textLayer';
    const page = document.createElement('div');
    page.className = 'investi-pdf-page';
    page.append(canvas, textLayer);
    elem.append(page);


    return elem;
  }

  //v2: scroll like the anchor would, but without setting the hash so the #sendGuid deep link survives
  preserveHashScroll(link:HTMLAnchorElement, v2:boolean){
    if(!v2) return;
    link.onclick = (e:MouseEvent) => {
      e.preventDefault();
      document.getElementById('investi-add-comment-container')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
  }

  getPaginationElement(parentElem:HTMLElement, paginationWidgetData:IPaginationWidgetData):HTMLElement{
    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-announcements-pagination-container';

    const infoElem: HTMLElement = document.createElement('div');
    infoElem.className = 'investi-announcements-pagination-showing-text'
    elem.appendChild(infoElem);

    const controlsElem: HTMLElement = document.createElement('div');
    controlsElem.className = 'investi-announcements-pagination-controls';
    const v2 = (paginationWidgetData as AnnouncementsInteractiveWidgetData).v2;
    const prevText = parentElem.closest('[data-investi-prev-text]')?.getAttribute('data-investi-prev-text');
    const nextText = parentElem.closest('[data-investi-next-text]')?.getAttribute('data-investi-next-text');
    const prevElem: HTMLButtonElement = this.getPaginationButton(true, prevText ?? (v2 ? '‹' : this.translate('Prev', paginationWidgetData.locale)), paginationWidgetData, parentElem)
    controlsElem.appendChild(prevElem);
    if(v2){
      const pagesElem: HTMLElement = document.createElement('div');
      pagesElem.className = 'investi-pagination-pages';
      controlsElem.appendChild(pagesElem);
    }
    const nextElem: HTMLButtonElement = this.getPaginationButton(false, nextText ?? (v2 ? '›' : this.translate('Next', paginationWidgetData.locale)), paginationWidgetData, parentElem)
    controlsElem.appendChild(nextElem);
    elem.appendChild(controlsElem);

    return elem;
  }

  //numbered page buttons (v2 pagination), windowed like 1 … 4 5 6 … 40
  renderPageNumbers(pagesElem:HTMLElement, parentElem:HTMLElement, paginationWidgetData:IPaginationWidgetData, totalPages:number){
    pagesElem.innerHTML = '';
    const current = paginationWidgetData.page;
    let prevShown = -1;
    for(let i = 0; i < totalPages; i++){
      if(i !== 0 && i !== totalPages - 1 && Math.abs(i - current) > 1){
        continue;
      }
      if(prevShown >= 0 && i - prevShown > 1){
        const gap: HTMLElement = document.createElement('span');
        gap.className = 'investi-pagination-ellipsis';
        gap.innerText = '…';
        pagesElem.appendChild(gap);
      }
      const button: HTMLButtonElement = document.createElement('button');
      button.className = 'investi-pagination-page' + (i === current ? ' investi-pagination-page-current' : '');
      button.innerText = `${i + 1}`;
      button.onclick = () => {
        paginationWidgetData.page = i;
        this.setAnnouncementTableRowsVisible(parentElem, paginationWidgetData);
      };
      pagesElem.appendChild(button);
      prevShown = i;
    }
  }

  getPaginationButton(isPrev:boolean, buttonText:string, paginationWidgetData:IPaginationWidgetData, elem:HTMLElement) : HTMLButtonElement{
    const button: HTMLButtonElement = document.createElement('button');
    button.className = `investi-announcements-pagination-controls-${isPrev?'prev':'next'}`;
    button.innerText = buttonText;

    button.onclick = (e:MouseEvent)=>{
      const { page }  = paginationWidgetData;

      if(page !== undefined){
        paginationWidgetData.page = page + (isPrev ? -1 : 1);
        this.setAnnouncementTableRowsVisible(elem, paginationWidgetData);
      }
    };
    return button;
  }



  getWidget<T>(target:EventTarget):T{
    let parent = (target as HTMLElement);
    let count = 0;
    while(count<20){
      const widget = parent as IWidgetElement<T>;
      if(widget.investi){
        return widget as T;
      }else{
        parent = parent.parentElement;
        count++;
      }
    }
    console.warn(`unable to find investi widget from child ${target}`)
  }


  setAnnouncementTableRowsVisible(elem:HTMLElement, paginationWidgetData:IPaginationWidgetData){

    const { page, rowClassName} = paginationWidgetData;
    let rows:HTMLElement[] = Array.from(elem.querySelectorAll<HTMLElement>(rowClassName));
    rows = this.filterRowsMatchingSearchbox(elem, rows);
    const numPerPage = paginationWidgetData.numPerPage || 1000000;

    const lower = page*numPerPage;
    const upper = Math.min(lower + numPerPage, rows.length);
    let visibleCount = 0;
    for (let i = 0; i < rows.length; i++) {
      const tr = rows[i];

      if(i >= lower && i < upper){
        tr.classList.remove(this.InteractiveAnnouncementsRowHiddenClassName)
        visibleCount++;

        if(visibleCount % 2 !== 0){
          tr.classList.add('investi-interactive-announcements-row-odd')
          tr.classList.remove('investi-interactive-announcements-row-even')
        }else{
          tr.classList.add('investi-interactive-announcements-row-even')
          tr.classList.remove('investi-interactive-announcements-row-odd')
        }
      }else{
        tr.classList.add(this.InteractiveAnnouncementsRowHiddenClassName)
      }
    }

    if(paginationWidgetData.numPerPage){
      let text = rows.length===0
        ? this.translate('No results', paginationWidgetData.locale)
        : `${this.translate('Showing', paginationWidgetData.locale)} ${lower+1}-${upper} ${this.translate('of', paginationWidgetData.locale)} ${rows.length}`
      const showingElem = elem.querySelector<HTMLElement>('.investi-announcements-pagination-showing-text');
      if(showingElem){
        showingElem.innerText = text;
        elem.querySelector<HTMLButtonElement>('.investi-announcements-pagination-controls-prev').disabled = page === 0;
        elem.querySelector<HTMLButtonElement>('.investi-announcements-pagination-controls-next').disabled = upper === rows.length;
        const pagesElem = elem.querySelector<HTMLElement>('.investi-pagination-pages');
        if(pagesElem){
          this.renderPageNumbers(pagesElem, elem, paginationWidgetData, Math.ceil(rows.length / numPerPage));
        }
      }else{

        console.warn(`pagination controls not found in containing elem`, elem)
      }
    }



  }

  filterRowsMatchingSearchbox(elem:HTMLElement, rows:HTMLElement[]){

    const val = this.getSearchboxText(elem);
    const filterText = (val || "").toLowerCase();
    const getTextFunc = (row:HTMLElement,):string => row.innerText;
    let filteredRows = [];
    for(let row of rows){
      if(filterText === ""){
        row.style.display = "";
        filteredRows.push(row)

      }else{
        const matches = getTextFunc(row).toLowerCase().indexOf(filterText)> -1;
        row.style.display =  matches ? "" : "none";
        if(matches){
          filteredRows.push(row)
        }

      }

    }
    return filteredRows;
  }

  getSearchboxText(x:HTMLElement){
    let elem = this.getWidget(x) as HTMLElement;
    let searchBox = elem.querySelector('.investi-searchbox') as HTMLInputElement

    if(searchBox){
      return searchBox.value;
    }else{
      console.warn('.investi-searchbox not found in elem', elem)
    }

  }

  setAnnouncementData(elem: HTMLElement, announcements:Announcement[], options: AnnouncementTableOptions) {
    var tableElem: HTMLElement = document.createElement('table');
    //tableElem.className = 'table table-striped table-bordered table-hover';
    var tableHeader: string = '<thead> <tr> <th>Date</th> <th>Headline</th> ';
    if (!options.hidePriceSensitive)
      tableHeader += '<th>Price Sensitive</th>';
    tableHeader +=' </tr> </thead> ';
    tableElem.innerHTML = tableHeader;
    var tableBody: HTMLElement = document.createElement('tbody');
    tableElem.appendChild(tableBody);

    elem.appendChild(tableElem);
    const numAnnouncements = options.numAnnouncements || announcements.length;
  const show = Math.min(numAnnouncements, announcements.length);
    const rows:HTMLElement[] = [];
    for (var i = 0; i < show; i++) {
      var announcement = announcements[i];
      var trElem: HTMLElement = document.createElement('tr');
      var tdDate: HTMLElement = document.createElement('td');
      var mySimpleDateFormatter = new simpleDateFormat(options.announcementDateFormat || 'dd MMM yy h:mm a', options.announcementDateFormat);

      //tdDate.innerHTML = this.formatDate(new Date(announcement.date));
      tdDate.innerHTML = mySimpleDateFormatter.format(new Date(announcement.date));

      let tdHeadline: HTMLElement = this.getAnnTdElement(announcement);
      tdHeadline.className = "investi-announcements-table-headline";
      var tdPriceSensitive: HTMLElement = document.createElement('td');
      tdPriceSensitive.innerHTML = announcement.priceSensitive ? "&#10004;" : "";

      trElem.appendChild(tdDate);
      trElem.appendChild(tdHeadline);
      if (!options.hidePriceSensitive)
        trElem.appendChild(tdPriceSensitive);

      tableBody.appendChild(trElem);
      rows.push(trElem)
    }

    const getTextFunc = (row:HTMLElement):string => row.querySelector<HTMLElement>(".investi-announcements-table-headline").innerText;

    if(elem.hasAttribute('data-investi-searchbox')){
      elem.prepend(this.createSearchBox(rows, { getTextFunc, locale: options.announcementLocale }));
    }
  }

  getAnnTdElement(announcement:Announcement): HTMLElement {
    var tdLink: HTMLElement = document.createElement('td');

    tdLink.appendChild(this.getAnnLink(announcement));
    return tdLink;
  }



  createInvestiAnnouncementSummary() {

    this.doActionOnIdOrClass(AnnouncementsSummaryWidgetName, (elem, apiKey) => {

      this.getAnnouncementData(apiKey, announcements => {
        this.createInvestiAnnouncementSummaryInternal(elem, announcements, false)
      });
    });
  }



  createInvestiAnnouncementSummaryInternal(elem: HTMLElement, container:IApiKeyWrapper, v2:boolean) {

    let announcements = container.announcements;
    if(this.checkSubscriptionExpired(elem, container))
      return;

    let numAnnouncements = 3;

    let dateFormat = elem.getAttribute('data-investi-date-format');
    if (elem.hasAttribute('data-investi-num-announcements'))
      numAnnouncements = parseInt(elem.getAttribute('data-investi-num-announcements'));

    announcements = this.filterAnnouncements(elem, announcements);

    this.setNoDataMessage(elem, announcements);

    if(isNaN(numAnnouncements)){
      numAnnouncements = announcements.length;
    }
    Math.min(numAnnouncements, announcements.length)
    const rows:HTMLElement[] = [];
    for (let i = 0; i < Math.min(numAnnouncements, announcements.length); i++) {

      const announcement = announcements[i];
      const date = this.getAnnouncementDate(dateFormat, announcement, this.getLocale(elem))

      if(v2){
        const priceSensitiveSymbol =elem.getAttribute('data-investi-price-sensitive-symbol');
        const row = this.createAnnouncementSummaryContent_v2(elem, announcement, date, priceSensitiveSymbol)
        this.setDedicatedPageLink(elem, row, announcement);
        rows.push(row)
      } else{
        this.createAnnouncementSummaryContent_v1(elem, announcement, date);
      }

    }

    const getTextFunc = (row:HTMLElement):string => row.querySelector<HTMLElement>(`.investi-announcement-headline`).innerText;

    if(v2 && elem.hasAttribute('data-investi-searchbox')){
      elem.prepend(this.createSearchBox(rows, { getTextFunc, locale: this.getLocale(elem) }));
    }
  }

  getAnnouncementDate(dateFormat:string, announcement:Announcement, locale:string):string {
    const mySimpleDateFormatter = new simpleDateFormat(dateFormat || 'dd MMM yyyy', locale);
    const date = mySimpleDateFormatter.format(new Date(announcement.date));
    return date;
  }

  createAnnouncementSummaryContent_v1(elem: HTMLElement, announcement, date) {
    var div: HTMLElement = document.createElement('div');

    div.innerHTML = date;
    var h4: HTMLElement = document.createElement('h4');
    let aHref = this.getAnnLink(announcement);
    h4.appendChild(aHref);

    elem.appendChild(div);
    elem.appendChild(h4);
  }

  createAnnouncementSummaryContent_v2(elem, announcement, date, priceSensitiveSymbol: string) : HTMLDivElement{
    var rowElem: HTMLDivElement = document.createElement('div');
    rowElem.className = 'investi-announcement-row';

  if (priceSensitiveSymbol) {
    rowElem.style.gridTemplateColumns = '120px max-content auto';
  }

    const dateElem: HTMLElement = document.createElement('div');
    dateElem.className = 'investi-announcement-date';
    dateElem.innerHTML = date;
    rowElem.appendChild (dateElem);
    
    if (priceSensitiveSymbol){
      const priceSensitiveElem: HTMLElement = document.createElement('div');
      priceSensitiveElem.className = 'investi-announcement-price-sensitive';
      priceSensitiveElem.innerHTML = announcement.priceSensitive ? priceSensitiveSymbol : '&nbsp;';
      rowElem.appendChild(priceSensitiveElem);
    }

    const headlineElem: HTMLElement = document.createElement('div');
    headlineElem.className = 'investi-announcement-headline';

    const aHref = this.getAnnLink(announcement);



    headlineElem.appendChild(aHref);
    rowElem.appendChild (headlineElem);

    elem.appendChild(rowElem);
    return rowElem;

  }

  createInvestiAnnouncementSummary_v2() {

    this.doActionOnIdOrClass(AnnouncementsSummaryv2WidgetName, (elem, apiKey) => {

      this.getAnnouncementData(apiKey, announcements => {
        this.createInvestiAnnouncementSummaryInternal(elem, announcements, true)
      });
    });
  }

  createStoriBotWidget() {
    this.doActionOnIdOrClass(StoriBotWidgetName, (elem, apiKey) => {
      this.getAnnouncementData(apiKey, container => {
        if(this.checkSubscriptionExpired(elem, container))
          return;
        const announcements = this.filterAnnouncements(elem, container.announcements).filter(x => x.storiBotUrl);
        const dateFormat = elem.getAttribute('data-investi-date-format');
        const backText = elem.getAttribute('data-investi-back-text') || '\u2190 Back to list';
        const rows = announcements.map(announcement => {
          const row = this.createAnnouncementSummaryContent_v2(elem, announcement, this.getAnnouncementDate(dateFormat, announcement, this.getLocale(elem)), null);
          const link = row.querySelector<HTMLAnchorElement>('a');
          link.href = announcement.storiBotUrl;
          link.removeAttribute('target');
          link.addEventListener('click', e => {
            e.preventDefault();
            list.style.display = 'none';
            back.style.display = '';
            iframe.src = announcement.storiBotUrl;
            iframe.style.display = '';
          });
          return row;
        });
        const list = document.createElement('div');
        list.className = 'investi-storibot-list';
        list.append(...rows);
        const back = document.createElement('a');
        back.className = 'investi-storibot-back';
        back.href = '#';
        back.innerText = backText;
        back.style.display = 'none';
        back.addEventListener('click', e => {
          e.preventDefault();
          iframe.style.display = 'none';
          iframe.src = 'about:blank';
          back.style.display = 'none';
          list.style.display = '';
        });
        const iframe = document.createElement('iframe');
        iframe.className = 'investi-storibot-frame';
        iframe.style.display = 'none';
        iframe.setAttribute('allow', 'autoplay; fullscreen; clipboard-write');
        elem.append(back, list, iframe);
        this.setNoDataMessage(list, announcements);
      });
    });
  }

  createInvestiAnnouncementTab() {

    this.doActionOnIdOrClass(AnnouncementsTabWidgetName, (e, apiKey) => {

      this.getAnnouncementData(apiKey, announcements => {
        const elem = e as AnnouncementsTabWidgetElement;
        //landed on an announcement url ({page}/{slug}-asx-{id}) without in-place detail: show it in the v2 detail view
        if(!this.isTabDetailInPlace(elem) && this.getAnnouncementIndexFromUrl(this.getAnnouncementsIgnoringYears(elem, announcements.announcements)) >= 0){
          //the v2 widget filters by these too; left on, it can't find an older (e.g. 2023) announcement to open
          elem.removeAttribute('data-investi-maximum-num-years');
          elem.removeAttribute('data-investi-start-year');
          elem.classList.replace(AnnouncementsTabWidgetName, AnnouncementsInteractiveV2WidgetName);
          elem.setAttribute('data-investi-no-comments', '');
          elem.setAttribute('data-investi-from-tab', '');
          elem.removeAttribute(WidgetCreatedAttrName);
          this.createInvestiAnnouncementsInteractiveTable();
          return;
        }
        elem.investi = {
          page: 0,
          numPerPage : +elem.getAttribute('data-investi-announcements-per-page'),
          rowClassName: ".investi-announcement-row",
          year: -1,
          priceSensitiveSymbol: elem.getAttribute('data-investi-price-sensitive-symbol'),
          locale: this.getLocale(elem)
        };
        this.createInvestiAnnouncementTabInternal(elem, announcements)
      });
    });
  }

  createSearchBox(rows:HTMLElement[], options:SearchBoxOptions) :HTMLDivElement  {
    const searchBoxContainer: HTMLDivElement = <HTMLDivElement>document.createElement('div');
    searchBoxContainer.className = 'investi-searchbox-container';
    const input: HTMLInputElement = <HTMLInputElement>document.createElement('input');
    input.setAttribute('placeholder', this.translate('Search...', options.locale));
    input.className = 'investi-searchbox';
    searchBoxContainer.append(input);

    const countElem: HTMLElement = <HTMLElement>document.createElement('div');
    countElem.className = 'investi-searchbox__results-count';
    searchBoxContainer.append(countElem);

    if(options.getTextFunc){
      input.onkeyup = e => {
        const count = this.setRowsVisible(input.value, rows, options.getTextFunc)
        countElem.innerText = count===undefined?'': `${count} match${count==1?'':'es'}`;
      };
    }else if(options.onkeyup){
      input.onkeyup = options.onkeyup;
    }


    return searchBoxContainer;
  }

  setRowsVisible(filterText:string, rows:HTMLElement[], getText:(row:HTMLElement)=>string) : number | undefined {

    filterText = (filterText || "").toLowerCase();

    if(filterText === ""){
      for(let row of rows){
        row.style.display = "";
      }
      return undefined;
    }

    let count = 0;
    for(let row of rows){
      const matches = getText(row).toLowerCase().indexOf(filterText)> -1;
      count += (matches ? 1 : 0);
      row.style.display =  matches ? "" : "none";
    }
    return count;
  }

  createInvestiAnnouncementTabInternal(elem: AnnouncementsTabWidgetElement, container:IApiKeyWrapper) {

    let announcements = container.announcements;
    if(this.checkSubscriptionExpired(elem, container))
      return;
    const dateFormat = elem.getAttribute('data-investi-date-format');
    const showSelect = elem.getAttribute('data-investi-include-select-for-additional-years')==='true';
    const locale = this.getLocale(elem);

    //  console.log('elem.investi', elem.investi)

    const rows:HTMLDivElement[] = [];
    announcements = this.filterAnnouncements(elem, announcements);
    this.setNoDataMessage(elem, announcements);

    const investiTab: HTMLDivElement = <HTMLDivElement>document.createElement('div');
    investiTab.classList.add("investi-tab");

    // Only set filter label if locale is specified or custom text is provided
    const customFilterText = elem.getAttribute('data-investi-filter-by-year-text');
    if (customFilterText) {
      investiTab.setAttribute('data-filter-label', customFilterText);
    } else if (locale) {
      investiTab.setAttribute('data-filter-label', this.translate('Filter by Year:', locale));
    }
    // If neither locale nor custom text, don't set attribute (no label shown)

    elem.appendChild(investiTab)


    let yearCount = 0;
    let tabContentDiv:HTMLElement|undefined;

    const options = this.getAnnouncementFilterOptions(elem);
    let groupedByYear = this.getAnnouncementsGrouped(this.filterAnnouncementsFromOptions(options, container.announcements));
    const years = Object.keys(groupedByYear).map(x=>+x).sort((a, b) => b-a);
    let currentYear = years[0]
    elem.investi.year = currentYear;
    for(let year of years){
      yearCount++;
      currentYear = year;
      const buttonElem: HTMLButtonElement = <HTMLButtonElement>document.createElement('button');
      buttonElem.className = "investi-tablinks";
      buttonElem.innerText = currentYear + "";
      buttonElem.setAttribute('data-investi-year', currentYear+'');
      buttonElem.addEventListener("click", (e:any)=> { this.onTabClick(e)});
      investiTab.appendChild(buttonElem);

      tabContentDiv = this.getAnnouncementTabContentDiv(currentYear);
      elem.appendChild(tabContentDiv);

      for(let announcement of groupedByYear[year]){
        const date = this.getAnnouncementDate(dateFormat, announcement, locale)
        const row = this.createAnnouncementSummaryContent_v2(tabContentDiv, announcement, date, elem.investi.priceSensitiveSymbol)
        this.setDedicatedPageLink(elem, row, announcement);
        rows.push(row);
      }
      //if using pagination add the pagination controls after the content rows
      if(elem.investi.numPerPage > 0){
        tabContentDiv.append(this.getPaginationElement(tabContentDiv, elem.investi))
      }
    }

    if(showSelect){
      const startYear = --currentYear;
      const optionsIgnoringMaxYear = {
        ...options,
        maxYears : undefined,
        startYear : undefined
      }
      groupedByYear = this.getAnnouncementsGrouped(this.filterAnnouncementsFromOptions(optionsIgnoringMaxYear, container.announcements));
      const priorYears = Object.keys(groupedByYear).map(x=>+x).filter(x=>x <= startYear).sort((a, b) => b-a);
      const priorYearText = elem.getAttribute('data-investi-select-prior-year-text') || this.translate('-- Prior Year --', locale);
      investiTab.appendChild(this.getAnnouncementTabSelect(startYear, priorYears, priorYearText));
      this.appendAdditionalYearsContent(elem, groupedByYear, priorYears, dateFormat, rows, elem.investi, locale);
    }

    if(elem.hasAttribute('data-investi-searchbox')){
      investiTab.append(this.createSearchBox(rows, { onkeyup: this.searchBox_onkeyup(), locale: locale }));
    }

    const firstButtonElement = elem.querySelector<HTMLButtonElement>('button');
    if(firstButtonElement){
      firstButtonElement.click();
    }

    if(this.isTabDetailInPlace(elem)){
      this.addTabDetailView(elem, this.getAnnouncementsIgnoringYears(elem, container.announcements));
    }
  }

  //dedicated page is this page: rows open the announcement in this widget (url still changes) instead of loading the page
  isTabDetailInPlace(elem:HTMLElement): boolean {
    return elem.hasAttribute('data-investi-dedicated-page')
      && this.getDedicatedPagePath(elem) === window.location.pathname.replace(AnnouncementSlugPathRegex, '').replace(/\/$/, '');
  }

  //a deep link can name an announcement older than the years shown
  getAnnouncementsIgnoringYears(elem:HTMLElement, announcements:Announcement[]): Announcement[] {
    return this.filterAnnouncementsFromOptions({ ...this.getAnnouncementFilterOptions(elem), maxYears: undefined, startYear: undefined }, announcements);
  }

  //tabs widget on its own dedicated page: shows the pdf in place, like v2.
  // 1. hidden pdf viewer + Back button inside the widget (same getPdfViewer/PdfViewer as v2, no comments)
  // 2. plain left-click on a row link: preventDefault, remember scroll, open in place
  //    (ctrl/middle-click and remote-hosted non-ASX links stay normal links)
  // 3. showAnnouncementDetail (shared with v2): adds investi-v2-showing-detail (css hides the list, shows the pdf), pushState, loads the pdf
  // 4. addDetailBackButton (shared with v2): Back drops the class and restores scroll; popstate re-opens whatever the url names
  // 5. landing on a detail url opens it here, no swap to the v2 widget
  //without dedicated-page, or when it names another page, none of this runs and the widget is unchanged
  async addTabDetailView(elem:AnnouncementsTabWidgetElement, announcements:Announcement[]){
    const openFromUrl = () => {
      const announcement = announcements[this.getAnnouncementIndexFromUrl(announcements)];
      if(!announcement)
        return false;
      this.openTabAnnouncement(elem, announcement);
      return true;
    };
    this.addDetailBackButton(elem, openFromUrl, () => {
      if(elem.investi.listScrollY === undefined){ //landed on the detail url: start of the list
        elem.scrollIntoView({ block: "start" });
        return;
      }
      window.scrollTo(0, elem.investi.listScrollY);
    });
    elem.append(this.getPdfViewer({ noComments: true, commentsWordingType: 'comment', v2: true }));

    await this.addPdfJsScript();

    elem.investi.pdfViewer = new PdfViewer(elem);
    //until here rows are plain links (full page load)
    elem.addEventListener('click', e => {
      if(e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)
        return; //new tab/window: let the link do it
      const link = (e.target as HTMLElement).closest<HTMLAnchorElement>('.investi-announcement-row a');
      if(!link || link.origin !== window.location.origin)
        return; //remote-hosted (non-ASX) announcements link straight to the pdf
      const announcement = announcements[this.getAnnouncementIndexFromUrl(announcements, link.pathname)];
      if(!announcement)
        return;
      e.preventDefault();
      elem.investi.listScrollY = window.scrollY;
      this.openTabAnnouncement(elem, announcement);
    });
    openFromUrl();
  }

  openTabAnnouncement(elem:AnnouncementsTabWidgetElement, announcement:Announcement){
    this.showAnnouncementDetail(elem, announcement);
    elem.scrollIntoView({ block: "start" }); //the list may be long, or a site header sits above it
  }

  searchBox_onkeyup(){
    const onkeyup = (e:KeyboardEvent) => {
      const widget = this.getWidget<IWidgetElement<IPaginationWidgetData>>(e.target);
      widget.investi.page = 0; //reset page to start to stop users going to an invalid page
      let elem:HTMLElement = widget;
      if(widget.classList.contains(AnnouncementsTabWidgetName)){
        elem = this.getAnnouncementSelectedTab(widget, (elem as AnnouncementsTabWidgetElement).investi.year );
      }
      this.setAnnouncementTableRowsVisible(elem, widget.investi)
    };
    return onkeyup;
  }

  getAnnouncementTabContentDiv(year:number){
    const contentDiv = <HTMLDivElement>document.createElement('div');
    contentDiv.className = "investi-tabcontent";
    contentDiv.setAttribute('data-investi-year', year+'');

    return contentDiv;
  }

  getAnnouncementsGrouped(announcements:Announcement[]){
    const groupedByYear = announcements.reduce((acc, announcement) => {
      const year = new Date(announcement.date).getFullYear(); // Get the full year from the ISO string
      if (!acc[year]) {
        acc[year] = [];
      }
      acc[year].push(announcement);
      return acc;
    }, {} as { [year: number]: Announcement[] });
    return groupedByYear;
  }

  appendAdditionalYearsContent(elem:AnnouncementsTabWidgetElement, groupedByYear:{ [year: number]: Announcement[] }, annYears:number[], dateFormat:string, rows:HTMLDivElement[], paginationWidgetData:IPaginationWidgetData, locale:string){

    for(let year of annYears){
      const tabContentDiv = this.getAnnouncementTabContentDiv(year)
      elem.appendChild(tabContentDiv);

      for(let announcement of groupedByYear[year]){
        const date = this.getAnnouncementDate(dateFormat, announcement, locale)
        const row = this.createAnnouncementSummaryContent_v2(tabContentDiv, announcement, date, elem.investi.priceSensitiveSymbol)
        this.setDedicatedPageLink(elem, row, announcement);
        rows.push(row);
      }

      if(paginationWidgetData.numPerPage > 0){
        tabContentDiv.append(this.getPaginationElement(tabContentDiv, paginationWidgetData))
      }
    }
  }

  getAnnouncementTabSelect(startYear:number, annYears:number[], priorYearText:string){

    const selectContainer = <HTMLDivElement>document.createElement('div');
    selectContainer.className = 'investi-tablinks investi-tab-additional-year-select-container';
    selectContainer.setAttribute('data-investi-year', startYear+'');
    // const yearLabel = <HTMLLabelElement>document.createElement('label');
    // yearLabel.className = 'investi-tab-additional-year-label'
    // yearLabel.innerText = 'Addtional Years: ';
    //selectContainer.append(yearLabel);

    const selectElem = <HTMLSelectElement>document.createElement('select');
    selectElem.className = 'investi-tab-additional-year-select';

    const optionYearElement = <HTMLOptionElement>document.createElement('option');
    selectElem.className = 'investi-tab-additional-year-option';

    optionYearElement.innerText = priorYearText;
    selectElem.appendChild(optionYearElement)

    for (let year of annYears) {
      const optionYearElement = <HTMLOptionElement>document.createElement('option');
      selectElem.className = 'investi-tab-additional-year-option';
      optionYearElement.innerText = `${year}`;
      selectElem.appendChild(optionYearElement)
    }


    selectContainer.append(selectElem);


    selectElem.addEventListener("change", (event:any) => {


      if(event.target.value != priorYearText){
        this.onTabClicked(selectContainer, event.target.value, this.getWidget(selectElem));
      }

    });

    return selectContainer;

  }
  onTabClick(e:PointerEvent){
    const button = e.target as HTMLButtonElement;
    const year = button.getAttribute('data-investi-year');
    this.onTabClicked(button, year, this.getWidget(e.target));

  }

  onTabClicked(tabLinkElem:HTMLElement, year:string, announcementsTabElem:AnnouncementsTabWidgetElement){

    announcementsTabElem.investi.year = +year;
    // Get all elements with class="tabcontent" and hide them
    const contents = announcementsTabElem.querySelectorAll<HTMLElement>(".investi-tabcontent");
    if(contents){
      for(let content of Array.from(contents)){
        if(!content.dataset.originalDisplay){
          const computedStyle = window.getComputedStyle(content).display;
          if(computedStyle && computedStyle !== 'none'){
            content.dataset.originalDisplay = computedStyle;

          }
        }
        content.style.display = 'none';
      }
    }

    // Get all elements with class="tablinks" and remove the class "active"
    const tablinks = announcementsTabElem.querySelectorAll<HTMLElement>(".investi-tablinks");
    if(tablinks){
      for (let i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");

      }

    }
   // Show the current tab, and
   const content = this.getAnnouncementSelectedTab(announcementsTabElem, announcementsTabElem.investi.year);
    if(content){

      content.style.display = content.dataset.originalDisplay || 'block';

      if(announcementsTabElem.investi.numPerPage > 0){     //is using pagination
        announcementsTabElem.investi.page = 0;//reset to first page when changing tabs

        this.setAnnouncementTableRowsVisible(content, announcementsTabElem.investi)

      }



    }else{
      console.error(`unable to find content div for year ${year}`)
    }
   //add an "active" class to the button/elem that opened the tab
   tabLinkElem.className += " active";

  }

  getAnnouncementSelectedTab(elem:HTMLElement, year:number){
    return elem.querySelector<HTMLElement>(`.investi-tabcontent[data-investi-year='${year}']`)
  }

  filterAnnouncements(elem: HTMLElement, announcements:Announcement[]) : Announcement[] {
    const options = this.getAnnouncementFilterOptions(elem);
    return this.filterAnnouncementsFromOptions(options, announcements);
  }

  getAnnouncementFilterOptions(elem: HTMLElement) : AnnouncementFilterOptions {
    const tagsAttr = elem.getAttribute('data-investi-tags');
    const tags = tagsAttr
      ? tagsAttr.split(',').map(t => t.trim().toLowerCase()).filter(t => t.length > 0)
      : undefined;
    const options:AnnouncementFilterOptions = {
      priceSensitiveOnly : elem.hasAttribute('data-investi-price-sensitive-only'),
      filterRegex : elem.getAttribute('data-investi-filter-regex'),
      maxYears : parseInt(elem.getAttribute('data-investi-maximum-num-years')),
      startYear : parseInt(elem.getAttribute('data-investi-start-year')),
      tags
    };
    return options;
  }



  filterAnnouncementsFromOptions(filterOptions: AnnouncementFilterOptions, announcements:Announcement[]) : Announcement[] {

    const { priceSensitiveOnly,filterRegex,maxYears,startYear,tags } = filterOptions;
    const hasTagFilter = !!(tags && tags.length);

    if(!priceSensitiveOnly && !filterRegex && !maxYears && !startYear && !hasTagFilter){
      return announcements;
    }
    const arr = [];
    let regExp: RegExp;
    if (filterRegex){
      regExp = new RegExp(filterRegex, "i");
    }

    const currentYear = new Date().getFullYear();

    for(let announcement of announcements){
      if (announcement.priceSensitive || !priceSensitiveOnly) {

        if (!filterRegex || announcement.headline.match(regExp)){

          const fullYear = new Date(announcement.date).getFullYear();

          if(!isNaN(startYear) && fullYear < startYear){
            continue;
          }

          if(maxYears && (currentYear - fullYear) >= maxYears){
            continue;
          }

          if(hasTagFilter){
            const annTagsRaw: string[] = ((announcement as any).tags || []) as string[];
            const annTags = annTagsRaw.map(t => t.toLowerCase());
            if(!annTags.some(t => tags.indexOf(t) !== -1)){
              continue;
            }
          }

          arr.push(announcement);
        }
      }
    }



    return arr;
  }

  getAnnLink(announcement:Announcement): HTMLAnchorElement {
    const aHref: HTMLAnchorElement = <HTMLAnchorElement>document.createElement('a');
    aHref.href =   this.getAnnouncementHref(announcement);
    aHref.target = "_blank";
    aHref.innerText = announcement.headline;
    return aHref;
  }

  getAnnouncementFilename(announcement:Announcement): string {
    return announcement.localPath.split('/').pop();
  }

  getAnnouncementId(announcement:Announcement): string {
    return this.getAnnouncementFilename(announcement).replace(/\.pdf$/i, '');
  }

  //the pdf
  getAnnouncementHref(announcement:Announcement): string {
    let href:string = announcement.localPath;
    if(!announcement.localPath.startsWith('http')){
      href = this.baseAddress + href;
    }
   return href;
  }

  //the page holding the announcements list: the data-investi-dedicated-page value (e.g. "asx-announcements/"), else this page minus any {slug}-asx-{id} segment
  getDedicatedPagePath(widgetElem:HTMLElement): string {
    const page = (widgetElem.getAttribute('data-investi-dedicated-page') || '').trim().replace(/^\/+|\/+$/g, '');
    return page ? `/${page}` : window.location.pathname.replace(AnnouncementSlugPathRegex, '').replace(/\/$/, '');
  }

  //{page}/{slug}-asx-{id}; remote-hosted (non-ASX) announcements have no detail page, so the raw url
  getAnnouncementDetailHref(widgetElem:HTMLElement, announcement:Announcement): string {
    if(announcement.localPath?.startsWith('/api/'))
      return `${this.getDedicatedPagePath(widgetElem)}/${this.getAnnouncementSlugPath(announcement)}`;
    return this.getAnnouncementHref(announcement);
  }

  createInvestiHeaderWidget() {
    var elems: HTMLCollectionOf<Element> = document.getElementsByClassName(HeaderPriceWidgetName);
    if (elems.length === 0)
      return;

    this.getMarketData('', (marketData) => {
      this.createPriceWidget(elems, marketData, true);
    });
  }

  createHeaderPrice() {
    var elems: HTMLCollectionOf<Element> = document.getElementsByClassName(HeaderPriceWidgetNamev2);
    if (elems.length === 0)
      return;

    this.getMarketData('', (marketData) => {
      this.createHeaderPriceInternal(elems, marketData);
    });
  }

  createinvestiPriceOnTopWidget() {
    var elems: HTMLCollectionOf<Element> = document.getElementsByClassName(PriceOnTopWidgetName);
    if (elems.length === 0)
      return;

    this.getMarketData('', (marketData) => {
      this.createPriceWidget(elems, marketData, false);
    });
  }

  createHeaderPriceInternal(elems: HTMLCollectionOf<Element>, container:IApiKeyWrapper) {
    const marketData = container.marketData;
    for (let i = 0; elems[i]; i++) {
      let elem = elems[i] as HTMLElement;
      if(this.checkSubscriptionExpired(elem, container))
        continue;
      const stockTicker: HTMLElement = document.createElement('div');
      stockTicker.className = 'investi-header-price-widget-ticker';
      elem.appendChild(stockTicker);
      stockTicker.innerHTML = `${marketData.exchange}:${marketData.ticker}`;

      const updatedDiv: HTMLElement = document.createElement('div');
      updatedDiv.innerHTML = this.formatDate(new Date(marketData.updated));
      updatedDiv.className = 'investi-header-price-widget-updated';
      elem.appendChild(updatedDiv);

      const momementDiv: HTMLElement = document.createElement('div');
      momementDiv.className = 'investi-header-price-widget-momement';
      const movementPercentElem: HTMLElement = document.createElement('div');
      movementPercentElem.className = 'investi-header-price-widget-movementPercentElem';
      this.setMovementElem(marketData, momementDiv, movementPercentElem, elem);
      elem.appendChild(momementDiv);
      elem.appendChild(movementPercentElem);

      let priceDiv = this.getPriceWidgetLastPriceDiv(this.addZeroes(marketData.last, elem), marketData.currency);
      priceDiv.className = 'investi-header-price-widget-last';
      elem.appendChild(priceDiv);
    }

  }

  createPriceWidget(elems: HTMLCollectionOf<Element>, container:IApiKeyWrapper, appendPriceAtEnd:boolean) {

    const marketData:StockMarketData = container.marketData;
    for (let i = 0; elems[i]; i++) {

      let elem = elems[i] as HTMLElement;
      if(this.checkSubscriptionExpired(elem, container))
        continue;
      //var container: HTMLElement = document.createElement('div');
      var cell1: HTMLElement = document.createElement('div');
      var stockTicker: HTMLElement = document.createElement('div');
      stockTicker.className = 'investi-header-price-widget-ticker';
      cell1.appendChild(stockTicker);
      stockTicker.innerHTML = `${marketData.exchange}:${marketData.ticker}`;

      var updatedDiv: HTMLElement = document.createElement('div');
      updatedDiv.innerHTML = this.formatDate(new Date(marketData.updated));
      updatedDiv.className = 'investi-header-price-widget-updated';
      cell1.appendChild(updatedDiv);

      var momementContainer: HTMLElement = document.createElement('div');
      momementContainer.className = 'investi-header-price-widget-container';
      var momementDiv: HTMLElement = document.createElement('span');
      momementDiv.className = 'investi-header-price-widget-momement';
      var movementPercentElem: HTMLElement = document.createElement('span');
      movementPercentElem.className = 'investi-header-price-widget-movementPercentElem';
      this.setMovementElem(marketData, momementDiv, movementPercentElem, elem);
      momementContainer.appendChild(momementDiv);
      momementContainer.appendChild(movementPercentElem);
      cell1.appendChild(momementContainer);
      let priceDiv = this.getPriceWidgetLastPriceDiv(this.addZeroes(marketData.last, elem), marketData.currency);
      if (!appendPriceAtEnd)
        elem.appendChild(priceDiv);
      elem.appendChild(cell1);
      if(appendPriceAtEnd)
        elem.appendChild(priceDiv);
    }

  }
  getPriceWidgetLastPriceDiv(last:number, currency:string): HTMLElement{
    var cell2: HTMLElement = document.createElement('div');
    this.setPriceWidgetLastPriceDiv(cell2, last, currency);
    return cell2;

  }

  setPriceWidgetLastPriceDiv(cell2: HTMLElement, last:number, currency:string): HTMLElement{

    var spanDollarSign: HTMLElement = document.createElement('span');
    spanDollarSign.innerHTML = this.getDollarSign(currency);
    spanDollarSign.className = 'investi-header-price-widget-dollar-sign';
    cell2.appendChild(spanDollarSign);

    var priceElem: HTMLElement = document.createElement('span');
    priceElem.innerHTML = last+'';
    priceElem.className = 'investi-header-price-widget-last-price';
    cell2.appendChild(priceElem);
    return cell2;
  }

  createInvestiAnnouncementAccordion(){
    this.doActionOnIdOrClass(AnnouncementsAccordionWidgetName, (elem, apiKey) => {
      this.getAnnouncementData(apiKey, announcements => {
        this.createInvestiAnnouncementAccordionInternal(elem, announcements)
      });
    });
  }

  setNoDataMessage(elem: HTMLElement, announcements:Announcement[]){
    if(!announcements.length){
      let noDataMessage =  elem.getAttribute('data-investi-no-data-message');
      if(!noDataMessage){
        noDataMessage = 'No announcements';
        if(elem.hasAttribute('data-investi-filter-regex')){
          noDataMessage += ` match the filter: ${elem.getAttribute('data-investi-filter-regex')}`;
        }
      }
      elem.innerHTML = noDataMessage;
    }
  }

  createInvestiAnnouncementAccordionInternal(elem: HTMLElement, container:IApiKeyWrapper) {

    let announcements = container.announcements;
    if(this.checkSubscriptionExpired(elem, container))
      return;

    let dateFormat = elem.getAttribute('data-investi-date-format');
    let showPriceSensitiveColumn = elem.hasAttribute('data-investi-show-price-sensitive-column') || false;
    let collapsed = elem.hasAttribute('data-investi-accordion-collapsed') || false;


    const rows:HTMLElement[] = []
    elem.innerHTML = '';
    var currentYear = -1;
    let tableCount = 0;
    let tableElem: HTMLElement;
    var that = this;
    announcements = this.filterAnnouncements(elem, announcements);

    this.setNoDataMessage(elem, announcements);

    for (var i = 0; i < announcements.length; i++) {
      var announcement = announcements[i];
      var annDate = new Date(announcement.date);

      if (annDate.getFullYear() != currentYear) {
        tableCount++;

        currentYear = annDate.getFullYear();
        var contDiv: HTMLElement = document.createElement('div');
        var headerYearElem: HTMLElement = document.createElement('h2');
        headerYearElem.innerHTML = currentYear + "";
        tableElem = document.createElement('table');
        headerYearElem.addEventListener('click', ((t,h2) => () => {
          that.toggleDisplay(t,h2);
        })(tableElem, headerYearElem));

        contDiv.appendChild(headerYearElem);
        contDiv.appendChild(tableElem);
        elem.appendChild(contDiv);

        if (tableCount > 1 || collapsed) {
          this.toggleDisplay(tableElem, headerYearElem);
        } else {
          headerYearElem.classList.add(this.activatedClassName);
        }

      }
      var trElem: HTMLElement = document.createElement('tr');
      var tdDate: HTMLElement = document.createElement('td');
      var mySimpleDateFormatter = new simpleDateFormat(dateFormat || 'dd MMM y', null);
      tdDate.innerHTML = mySimpleDateFormatter.format(new Date(announcement.date.substring(0,10)));
      let tdLink: HTMLElement = document.createElement('td');
      tdLink.className = "investi-announcement-accordion-headline";
      tdLink.appendChild(this.getAnnLink(announcement));
      trElem.appendChild(tdDate);

      if (showPriceSensitiveColumn) {
        var tdPriceSensitive: HTMLElement = document.createElement('td');
        tdPriceSensitive.innerHTML = announcement.priceSensitive ? "&#10004;" : "";
        trElem.appendChild(tdPriceSensitive);
      }
      trElem.appendChild(tdLink);

      tableElem.appendChild(trElem);
      rows.push(trElem)

    }

    const getTextFunc = (row:HTMLElement):string => row.querySelector<HTMLElement>(".investi-announcement-accordion-headline").innerText;

    if(elem.hasAttribute('data-investi-searchbox')){
      elem.prepend(this.createSearchBox(rows, { getTextFunc, locale: this.getLocale(elem) }));
    }
  }



  toggleDisplay(elem: HTMLElement, headerYearElem: HTMLElement) {

    if (elem.style.display === "none") {
      elem.style.display = "";
      headerYearElem.classList.add(this.activatedClassName);
    } else {
      elem.style.display = "none";
      headerYearElem.classList.remove(this.activatedClassName);
    }

  }

  createCarousel(){

    this.doActionOnIdOrClass(AnnouncementsCarouselWidgetName, (elem, apiKey) => {

      this.getAnnouncementData(apiKey, announcements => {

        this.createCarouselInternal(elem, announcements);

      });
    });

  }

  createCarouselInternal(elem:HTMLElement, container:IApiKeyWrapper) {
    if(typeof jQuery == 'undefined'){
      console.error('investi: jquery required for Carousel')
      return;
    }

    if (typeof jQuery().slick !== "function"){
      console.error('investi: slick required for Carousel')
      return;
    }


    let announcements = container.announcements;
    if(this.checkSubscriptionExpired(elem, container))
      return;

    const dateFormat = elem.getAttribute('data-investi-date-format');

    announcements = this.filterAnnouncements(elem, announcements);

    for (let j = 0; j < Math.min(9, announcements.length); j++) {

      var contDiv: HTMLElement = document.createElement('div');
      contDiv.classList.add('investi-carousel_announcement-container')

      var dateDiv: HTMLElement = document.createElement('div');
      dateDiv.classList.add('investi-carousel_announcement-date')
      var mySimpleDateFormatter = new simpleDateFormat(dateFormat || 'dd MMM y', null);
      dateDiv.innerHTML = mySimpleDateFormatter.format(new Date(announcements[j].date.substring(0,10)));
      contDiv.appendChild(dateDiv);

      var headlineDiv: HTMLElement = document.createElement('div');
      headlineDiv.classList.add('investi-carousel_announcement-headline')
      headlineDiv.appendChild(this.getAnnLink(announcements[j]));
      contDiv.appendChild(headlineDiv);

      elem.appendChild(contDiv);
    }
    let options= this.getCarouselOptions();
    const optionsFunc = elem.getAttribute('data-investi-carousel-options');
    if(optionsFunc){
      if (typeof window[optionsFunc] === 'function') {
        // options = Object.assign({}, options, window[optionsFunc]());
        options = window[optionsFunc]()
      } else {
        console.warn(`data-investi-carousel-options defines function ${optionsFunc} which is not defined`);
      }
    }

    jQuery(elem).slick(options);
  }

  getCarouselOptions() {
    return {
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst:true,
      responsive: [
        {
          breakpoint: 1460,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
      ]
    }
  }

  createAnnouncementsThumbnail(){

    for(let widgetName of [ AnnouncementsLatestPresentationWidgetName, AnnouncementsReportsWidgetName, AnnouncementsThumbnailWidgetName  ]){
      this.doActionOnIdOrClass(widgetName, (elem, apiKey) => {

        this.getAnnouncementData(apiKey, announcements => {

          this.createAnnouncementsThumbnailInternal(elem, announcements, widgetName);

        });
      });
    }


  }

  createAnnouncementsThumbnailInternal(elem:HTMLElement, container:IApiKeyWrapper, widgetName:string) {



    if(this.checkSubscriptionExpired(elem, container))
      return;

      //data-investi-filter-regex=""

    const options = this.getAnnouncementFilterOptions(elem);
    let width = +elem.getAttribute('data-investi-thumbnail-image-width');
    let height = +elem.getAttribute('data-investi-thumbnail-image-height');
    let numAnnouncements = parseInt(elem.getAttribute('data-investi-num-announcements'))
    if(!elem.classList.contains(AnnouncementsThumbnailWidgetName)){
      elem.classList.add(AnnouncementsThumbnailWidgetName)
    }

    if(widgetName===AnnouncementsLatestPresentationWidgetName){
      options.filterRegex = options.filterRegex || 'presentation'
      width = width || 450;
      height = height || 450;

    } else if(widgetName===AnnouncementsReportsWidgetName){
      options.filterRegex = options.filterRegex || 'annual.*report|quarterly.*report|half.*report';
      numAnnouncements = numAnnouncements || 6;
    }

    const announcements = this.filterAnnouncementsFromOptions(options, container.announcements);
    if(!numAnnouncements){
      numAnnouncements=1;
    }
    if(numAnnouncements === 1){
      elem.classList.add('data-investi-announcements-thumbnail-single-announcement-only')
    }
    width = width || 250;
    height = height || 250;

    const MaxNumThumbnails = 50;
    if(numAnnouncements > MaxNumThumbnails){
      console.warn(`cannot show more than ${MaxNumThumbnails} announcement thumbnails`)
      numAnnouncements = MaxNumThumbnails;
    }

    const dateFormat = this.getDateFormat(elem);

    if(announcements.length){

      const count = Math.min(announcements.length, numAnnouncements);
      for (let i = 0; i < count; i++) {
        const announcement = announcements[i];
        elem.append(this.getAnnouncementThumbnailElem(announcement, dateFormat, width, height));
      }

    }else{
      this.setNoDataMessage(elem, announcements);
    }


  }

  getAnnouncementThumbnailElem(announcement:Announcement, dateFormat:string, width:number|string, height:number|string){



    const anchorElem = this.getAnnLink(announcement);
    anchorElem.innerText = '';
    anchorElem.className = 'investi-announcements-thumbnail__anchor';
    const div: HTMLDivElement = document.createElement('div');
    div.className = 'investi-announcements-thumbnail__header';

    {
      const img: HTMLImageElement = document.createElement('img');
      let imgSrc = anchorElem.href.replace(/\.pdf$/, `_${width}x${height}.jpg`);
      img.src = imgSrc.replace("announcements", "announcementthumbnail");
      anchorElem.append(img)
    }

    const headline = document.createElement('div');
    headline.className = 'investi-announcements-thumbnail__headline';
    headline.innerText = announcement.headline;
    div.appendChild(headline);

    const dateFormatter = new simpleDateFormat(dateFormat || 'dd MMM yy', null);
    const dateElem = document.createElement('div');
    dateElem.className = 'investi-announcements-thumbnail__date';
    dateElem.innerText = dateFormatter.format(new Date(announcement.date));
    div.appendChild(dateElem);



    anchorElem.append(div);



    return anchorElem
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }



  doActionOnIdOrClass(idOrClassName:string, action:(elem:HTMLElement, apiKey:string)=>void){


    let elem: HTMLElement = document.getElementById(idOrClassName);
    let arr:HTMLElement[] = [];
    if (elem != null){
      arr.push(elem);
    }
    for(let elem of Array.from(document.getElementsByClassName(idOrClassName))){
      arr.push(<HTMLElement>elem);
    }
    for(let elem of arr){
      if(!elem.hasAttribute(WidgetCreatedAttrName)){
        action(elem, elem.getAttribute('apiKey'));
        elem.setAttribute(WidgetCreatedAttrName, '1');
      }else{
        console.warn(`elem ${idOrClassName} already created. are you referencing investi.js more than once?`)
      }

    }
  }

  createInvestiMarketDataIndividualFields(){

    for(let elemName of MarketDataElemNames){

      this.doActionOnIdOrClass(elemName, (elem, apiKey) => {
        this.getMarketData(apiKey, (container)=>{
          const data = container.marketData;
          if(this.checkSubscriptionExpired(elem, container))
            return;
          if(elemName===SharePriceSymbolElementName){
            this.setSharePriceSymbol(elem, data);
          }else if(elemName===SharePriceMovement){
            this.setSharePriceMovement(elem, data);
          }else if(elemName===SharePriceLastElementName){
            this.setSharePriceLast(elem, data);
          }else if(elemName===SharePriceMovementPercent){
            this.setSharePriceMovementPercent(elem, data.movementPercent);
          }else if(elemName===ShareMarketCapName){
            this.setMarketCap(elem, data);
          }else if(elemName===SharesOnIssueName){
            this.setMarketDataFieldWithCommas(elem, data.sharesOnIssue);
          }else if(elemName===SharePriceVolumeElementName){
            this.setMarketDataFieldWithCommas(elem, data.volume);
          }else if(elemName===SharePriceUpdateTime){
            this.setDateField(elem, data.updated, () => this.formatAMPM(new Date(data.updated)));
          }else if(elemName===SharePriceUpdateDate){
            this.setDateField(elem, data.updated, () => this.formatDateOnly(new Date(data.updated)));
          }else if(elemName===SharePriceUpdated){
            this.setDateField(elem, data.updated, () => this.formatAMPM(new Date(data.updated)) + " " + this.formatDateOnly(new Date(data.updated)));
          }else{
            this.setMarketDataField(elem, data, elemName);
          }


        })
      });
    }

  }

  setDateField(elem:HTMLElement, updated:string, defaultFormatting:()=>string){
    const dateFormatAttr = this.getDateFormat(elem);
    if(dateFormatAttr){
      const dateFormatter = new simpleDateFormat(dateFormatAttr, null);
      elem.innerHTML = dateFormatter.format(updated);
    }else{
      elem.innerHTML = defaultFormatting();
    }
  }

  setSharePriceLast(elem:HTMLElement, data:StockMarketData){
    const hasPrefix = elem.hasAttribute('data-investi-prefix-currency-symbol');
    elem.innerHTML = (hasPrefix ? this.getCurrencySymbolPrefix(data):'') + this.addZeroes(data.last, elem);
  }

  setMarketDataField(elem:HTMLElement, data:StockMarketData, elemName:string){
    const tokens = elemName.split('-');
    const fieldName = tokens[tokens.length-1];

    if(data.hasOwnProperty(fieldName)){

      let fieldValue = this.getFormattedMarketDataNumericField(data[fieldName], elem);
      elem.innerHTML = this.getCurrencySymbolPrefix(data) + fieldValue;
    }else{
      console.warn(`unknown marketData proprety ${elemName}`)
    }
  }

  getCurrencySymbolPrefix(data:StockMarketData) : string{
    return `<span class="investi-currency-symbol">${this.getDollarSign(data.currency)}</span>`;
  }

  getFormattedMarketDataNumericField(fieldValue:any, elem:HTMLElement){
    const attrVal = elem.getAttribute('investi-num-decimal-places');

    const parsed = attrVal != null ? parseInt(attrVal) : NaN;
    const numDecimalPlaces = isNaN(parsed) ? 2 : parsed;
    const parsedFloat = parseFloat(fieldValue);
    if(!isNaN(parsedFloat)){
      if(attrVal){ //format explicitly defined
        fieldValue = parsedFloat.toLocaleString(undefined, { 
          minimumFractionDigits: numDecimalPlaces,
          maximumFractionDigits: numDecimalPlaces
        });                
      }else{
        fieldValue = this.formatNumber(parsedFloat, numDecimalPlaces);
      }

    }
    return fieldValue;
  }

  formatNumber(num:number, dp:number):string {
    // Convert the number to a string and split it into integer and decimal parts
    const [integerPart, decimalPart] = num.toString().split('.');

    // Check if there's a decimal part and its length
    if (decimalPart && decimalPart.length > 2) {
        // If more than two decimal places, return the number as is with its original decimal part
        return integerPart + '.' + decimalPart;
    } else {
        // If two or fewer decimal places, use toFixed(2)
        return num.toFixed(dp);
    }
}

  setSharePriceSymbol(elem:HTMLElement, marketData:StockMarketData){
    elem.innerHTML = `${marketData.exchange}:${marketData.ticker}`;
  }

  createSecFilingsWidget(){

    this.doActionOnIdOrClass(SecFilingsWidgetName, (elem, apiKey) => {
      const container = this.ensureContainer(apiKey);

      this.sendRequest('/api/secFilings', apiKey,
      json => {

        this.setContainerField(container, json, x =>container.secFilingResult = x)

        if(this.checkSubscriptionExpired(elem, container))
          return;

        const onSelectChanged = () => {
          this.createSecFilingsTable(apiKey, elem);
        }
        elem.appendChild(this.getSecFilingsFilter(onSelectChanged));

        onSelectChanged();

      });
    });
  }

  createSecFilingsTable(apiKey:string, elem:HTMLElement) {

    const filterElem = document.getElementsByClassName('investi-sec-filings__filter-select').item(0) as HTMLSelectElement;

    const container = this.ensureContainer(apiKey);
    const dateFormat = this.getDateFormat(elem);
    const dateFormatter = new simpleDateFormat(dateFormat || 'dd MMM yyyy', null);
    let currentYear = -1;
    let tableCount = 0;
    let tableElem: HTMLTableElement;
    const that = this;
    const containerClassname = 'investi-sec-filings__table-container'
    const elements = document.getElementsByClassName(containerClassname);
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }

    for(let filing of container.secFilingResult?.secFilings){

      const formTypes = filterElem.value.split(',');

      if(!filterElem.value || formTypes.includes(filing.form)){

        const date = new Date(filing.date);

      if (date.getFullYear() != currentYear) {
        tableCount++;

        currentYear = date.getFullYear();
        var contDiv: HTMLElement = document.createElement('div');
        contDiv.className = containerClassname;
        var headerYearElem: HTMLElement = document.createElement('h2');
        headerYearElem.innerHTML = currentYear + "";
        tableElem = this.createSecFilingsWidgetTable();
        headerYearElem.addEventListener('click', ((t,h2) => () => {
          that.toggleDisplay(t,h2);
        })(tableElem, headerYearElem));

        contDiv.appendChild(headerYearElem);
        contDiv.appendChild(tableElem);
        elem.appendChild(contDiv);

        if (tableCount > 1) {
          this.toggleDisplay(tableElem, headerYearElem);
        } else {
          headerYearElem.classList.add(this.activatedClassName);
        }

      }
      this.createSecFilingsWidgetTableRow(filing, dateFormatter.format(date), tableElem)
      }



    }
  }



  getSecFilingsFilter(onSelectChanged:()=>void) : HTMLElement {

    const span = document.createElement('span');
    span.className = "investi-sec-filings__filter-label"
    span.innerText = "Filter filing type:"

    const select = document.createElement('select');
    select.className = "investi-sec-filings__filter-select"

    select.appendChild(this.getSecFilingSelectFilterOption("All Form Types", ""));
    select.appendChild(this.getSecFilingSelectFilterOption("Annual Filings", "10-K"));
    select.appendChild(this.getSecFilingSelectFilterOption("Quarterly Filings", "10-Q"));
    select.appendChild(this.getSecFilingSelectFilterOption("Current Reports", "8-K"));
    select.appendChild(this.getSecFilingSelectFilterOption("Proxy Filings", "DEFA14A,DEF 14A"));
    select.appendChild(this.getSecFilingSelectFilterOption("SEC Staff Action", "SEC STAFF ACTION"));
    select.appendChild(this.getSecFilingSelectFilterOption("Statement of beneficial ownership of securities", "3"));
    //select.appendChild(this.getSecFilingSelectFilterOption("zzz", "zzz"));
    select.addEventListener('change', (event) => {

      onSelectChanged();
    });

    const contDiv = document.createElement('div');
    contDiv.className = "investi-sec-filings__filter-container"
    contDiv.appendChild(span);
    contDiv.appendChild(select);
    /*
    <select class="dropdown module_options-select module-sec_type-select" id="SecFilingType">
        <option selected="selected" value="">All Form Types</option>
        <option value="1,4">Annual Filings</option>
        <option value="2">Quarterly Filings</option>
        <option value="9,40">Current Reports</option>
        <option value="11,17">Proxy Filings</option>
        <option value="41">Registration Statements</option>
        <option value="13">Section 16 Filings</option>
        <option value="3,20,21,30,33,34,35,36,37,42">Other</option>
    </select>
    */
   return contDiv;
  }

  getSecFilingSelectFilterOption(text:string, value:string|undefined) : HTMLOptionElement {
    const option = document.createElement('option');
    option.innerText = text;
    option.value = value;
    return option;
  }

  createSecFilingsWidgetTable(): HTMLTableElement{

    const table = document.createElement('table');
    const thead = document.createElement('thead');
    thead.innerHTML = "<tr><th>Date</th><th>Form</th><th>Description</th><th>Download</th></tr>";
    const tbody = document.createElement('tbody');
    table.appendChild(thead);
    table.appendChild(tbody);

    return table;
  }

  createSecFilingsWidgetTableRow(filing:SecFiling, date:string, table:HTMLTableElement){
    const tbody = table.querySelector<HTMLTableSectionElement>('tbody');
    const tr: HTMLElement = document.createElement('tr');

    const dateTd = document.createElement('td');

    dateTd.innerHTML = date;
    tr.appendChild(dateTd);

    const formTd = document.createElement('td');
    formTd.innerHTML = filing.form;
    tr.appendChild(formTd);

    const descriptionTd = document.createElement('td');
    descriptionTd.innerHTML = filing.description;
    tr.appendChild(descriptionTd);

    const download: HTMLElement = document.createElement('td');
    for(let file of filing.files){

      const span = document.createElement('span');
      download.appendChild(span);
      let fileTypeCss = 'fiv-icon-blank';
      if(file.secFilingDocumentType == SecFilingDocumentType.Html){
        fileTypeCss ="fiv-icon-html";
      }else if(file.secFilingDocumentType == SecFilingDocumentType.Pdf){
        fileTypeCss ="fiv-icon-pdf";
      }
      else if(file.secFilingDocumentType == SecFilingDocumentType.Xml){
        fileTypeCss ="fiv-icon-xml";
      }
      else if(file.secFilingDocumentType == SecFilingDocumentType.Zip){
        fileTypeCss ="fiv-icon-zip";
      }
      span.className = `fiv-cla fiv-size-md ${fileTypeCss}`;
      const anchor: HTMLAnchorElement = <HTMLAnchorElement>document.createElement('a');
      const url = (file.url.startsWith('/api/') ? this.baseAddress : '') + file.url;
      anchor.href = url;
      anchor.target = "_blank";
      // anchor.innerText = "html";
      anchor.appendChild(span);
      download.appendChild(anchor);
    }

    tr.appendChild(download);
    tbody.appendChild(tr);
  }

  createAddSubscriberWidget(){

    const getFormField = (placeholder, className) : HTMLInputElement =>  {
      const inputElem:HTMLInputElement = document.createElement('input');
      inputElem.placeholder = placeholder;
      inputElem.className = `investi-add-subscriber__${className}`;
      inputElem.name = inputElem.className;
      return inputElem;
    }

    this.doActionOnIdOrClass(AddSubscriberWidgetName, (elem, apiKey) => {

      const firstName = getFormField('First Name', 'first-name');
      const lastName = getFormField('Last Name', 'last-name');
      const email = getFormField('Email', 'email')
      elem.append(firstName);
      elem.append(lastName);
      elem.append(email);

      // Optional "Email Alerts" checkboxes and "Shareholder" radios.
      // Both sections only render when their data-investi-* attribute is present, so the
      // widget behaves identically to before when neither attribute is supplied.
      const emailAlertsShown = elem.hasAttribute('data-investi-email-alerts-options');
      const shareholderShown = elem.hasAttribute('data-investi-is-shareholder-option');

      const makeOption = (type: 'checkbox' | 'radio', labelText: string, group?: string): { row: HTMLLabelElement, input: HTMLInputElement } => {
        const row = document.createElement('label');
        row.className = 'investi-add-subscriber__option';
        const input = document.createElement('input');
        input.type = type;
        if (group) input.name = group;
        const span = document.createElement('span');
        span.innerText = labelText;
        row.append(input, span);
        return { row, input };
      };

      let announcementsCheckbox: HTMLInputElement | null = null;
      let otherCheckbox: HTMLInputElement | null = null;
      if (emailAlertsShown) {
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'investi-add-subscriber__fieldset';
        const legend = document.createElement('legend');
        legend.className = 'investi-add-subscriber__legend';
        legend.innerText = elem.getAttribute('data-investi-email-alerts-heading') || 'Email Alerts';
        fieldset.append(legend);

        const ann = makeOption('checkbox', elem.getAttribute('data-investi-email-alerts-announcements-text') || 'ASX Announcements');
        const other = makeOption('checkbox', elem.getAttribute('data-investi-email-alerts-other-text') || 'Media Releases and other news');
        announcementsCheckbox = ann.input;
        otherCheckbox = other.input;
        announcementsCheckbox.checked = true;
        otherCheckbox.checked = true;
        fieldset.append(ann.row, other.row);
        elem.append(fieldset);
      }

      let shareholderYesRadio: HTMLInputElement | null = null;
      let shareholderNoRadio: HTMLInputElement | null = null;
      if (shareholderShown) {
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'investi-add-subscriber__fieldset';
        const legend = document.createElement('legend');
        legend.className = 'investi-add-subscriber__legend';
        legend.innerText = elem.getAttribute('data-investi-is-shareholder-text') || 'Do you currently hold shares in this Company?';
        fieldset.append(legend);

        const yes = makeOption('radio', 'Yes', 'investi-add-subscriber__shareholder');
        const no = makeOption('radio', 'No', 'investi-add-subscriber__shareholder');
        shareholderYesRadio = yes.input;
        shareholderNoRadio = no.input;
        fieldset.append(yes.row, no.row);
        elem.append(fieldset);
      }

      const submittingElem = this.getLoadingElem()
      submittingElem.classList.add('investi-add-subscriber__submitting');
      const submitElem:HTMLButtonElement = document.createElement('button');
      submitElem.innerText = elem.getAttribute('data-investi-submit-button-text') || "Submit";
      submitElem.className = `investi-add-subscriber__submit`;



      const feedbackElement:HTMLDivElement = document.createElement('div');
      feedbackElement.className = `investi-add-subscriber__feedback`;

      elem.append(submitElem);
      elem.append(submittingElem);
      elem.append(feedbackElement);

      const showGoogle = elem.hasAttribute('data-investi-google-subscribe');
      const showLinkedIn = elem.hasAttribute('data-investi-linkedin-subscribe');
      const showOneTap = elem.hasAttribute('data-investi-google-one-tap');

      if (showOneTap) {
        const key = apiKey || this.apiKeys[0].apiKey;
        const showFeedback = (success: boolean, message: string) => {
          const feedbackMsg = elem.getAttribute('data-investi-subscribed-feedback') || message || 'Subscribed!';
          feedbackElement.innerText = success ? feedbackMsg : (message || 'Something went wrong. Please try again.');
          feedbackElement.classList.remove('investi-success', 'investi-error');
          feedbackElement.classList.add(success ? 'investi-success' : 'investi-error');
        };

        // Fetch Google Client ID then load GSI script
        this.httpCall<{clientId: string}>('GET', `${this.baseAddress}/api/subscriber/google-client-id`)
          .then(({clientId}) => {
            if (!clientId) return;
            const script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client';
            script.onload = () => {
              (window as any).google.accounts.id.initialize({
                client_id: clientId,
                use_fedcm_for_prompt: true,
                callback: async (response: any) => {
                  try {
                    const result = await this.httpCall<{success: boolean, message: string}>('POST',
                      `${this.baseAddress}/api/subscriber/google-one-tap`,
                      { credential: response.credential, apiKey: key });
                    showFeedback(result.success, result.message);
                  } catch (e) {
                    showFeedback(false, 'Something went wrong. Please try again.');
                  }
                }
              });
              (window as any).google.accounts.id.prompt();
            };
            document.head.appendChild(script);
          });
      }

      if (showGoogle || showLinkedIn) {
        const divider = document.createElement('hr');
        divider.className = 'investi-add-subscriber__divider';
        elem.append(divider);

        const socialContainer = document.createElement('div');
        socialContainer.className = 'investi-add-subscriber__social';

        const openSocialPopup = (url: string) => {
          const w = 500, h = 600;
          const left = window.screenX + (window.outerWidth - w) / 2;
          const top = window.screenY + (window.outerHeight - h) / 2;
          window.open(url, 'investi-social-subscribe', `width=${w},height=${h},left=${left},top=${top}`);
        };

        // Listen for result from popup
        window.addEventListener('message', (event) => {
          if (event.data?.type !== 'investi-subscribe') return;
          const success = event.data.status === 'success';
          const feedbackMsg = elem.getAttribute('data-investi-subscribed-feedback') || event.data.message || 'Subscribed!';
          feedbackElement.innerText = success ? feedbackMsg : (event.data.message || 'Something went wrong. Please try again.');
          feedbackElement.classList.remove('investi-success', 'investi-error');
          feedbackElement.classList.add(success ? 'investi-success' : 'investi-error');
        });

        if (showGoogle) {
          const googleBtn = document.createElement('button');
          googleBtn.type = 'button';
          googleBtn.className = 'investi-add-subscriber__google-btn';
          googleBtn.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg> Subscribe with Google`;
          googleBtn.addEventListener('click', () => {
            const key = apiKey || this.apiKeys[0].apiKey;
            const returnUrl = window.location.href;
            openSocialPopup(`${this.baseAddress}/api/subscriber/google-login?apiKey=${encodeURIComponent(key)}&returnUrl=${encodeURIComponent(returnUrl)}`);
          });
          socialContainer.append(googleBtn);
        }

        if (showLinkedIn) {
          const linkedInBtn = document.createElement('button');
          linkedInBtn.type = 'button';
          linkedInBtn.className = 'investi-add-subscriber__linkedin-btn';
          linkedInBtn.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18"><path fill="#fff" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg> Subscribe with LinkedIn`;
          linkedInBtn.addEventListener('click', () => {
            const key = apiKey || this.apiKeys[0].apiKey;
            const returnUrl = window.location.href;
            openSocialPopup(`${this.baseAddress}/api/subscriber/linkedin-login?apiKey=${encodeURIComponent(key)}&returnUrl=${encodeURIComponent(returnUrl)}`);
          });
          socialContainer.append(linkedInBtn);
        }

        elem.append(socialContainer);
      }

      submitElem.addEventListener('click', async () => {
        submitElem.disabled = true;
        submittingElem.style.display = 'inline-block';
        feedbackElement.innerHTML='';
        feedbackElement.classList.remove('investi-success')
        feedbackElement.classList.remove('investi-error')

        // Shareholder answer is required when its section is shown.
        if (shareholderShown && !shareholderYesRadio.checked && !shareholderNoRadio.checked) {
          submittingElem.style.display = 'none';
          submitElem.disabled = false;
          feedbackElement.innerText = 'Please tell us if you hold shares in this Company';
          feedbackElement.classList.add('investi-error');
          return;
        }

        // Capture the opted-in answers as tags.
        const tags:string[] = [];
        if (emailAlertsShown) {
          if (announcementsCheckbox.checked) tags.push('announcements');
          if (otherCheckbox.checked) tags.push('other-news');
        }
        if (shareholderShown && shareholderYesRadio.checked) {
          tags.push('shareholder');
        }
        // Opt-in fixed tag, e.g. data-investi-tag="Embed Form" tags every subscriber from this form.
        const fixedTag = elem.getAttribute('data-investi-tag');
        if (fixedTag) {
          tags.push(fixedTag);
        }

        let result:AddSubscriberResult;
        try {
          const data:AddSubscriberRequest = {
            apiKey: apiKey || this.apiKeys[0].apiKey,
            firstName: firstName.value,
            lastName: lastName.value,
            email: email.value,
            tags
          }
          result = await this.httpCall<AddSubscriberResult>('POST', `${this.baseAddress}/api/subscriber`, data)
        } catch (e) {
          let errorMessage = !!e.errorMessage ? e.errorMessage : JSON.stringify(e);
          result = { errorMessage, feedback: '' }
        }

        submittingElem.style.display = 'none';
        submitElem.disabled = false;
        let success = !result.errorMessage;
        const feedbackMsg = elem.getAttribute('data-investi-subscribed-feedback') || result.feedback || 'Subscribed!';
        feedbackElement.innerText = success ?  feedbackMsg : result.errorMessage;
        feedbackElement.classList.add(success ? 'investi-success': 'investi-error')
      });


    });
  }

  addSubscriberClicked(){

  }

  createInvestiLoginWidget(){

    this.doActionOnIdOrClass(LoginWidgetName, (elem, apiKey) => {

      const key = apiKey || this.apiKeys[0].apiKey;
      const lastUsedStorageKey = LastLoginStorageKey;
      let feedbackElement: HTMLDivElement = null;
      let companyName = '';

      const showFeedback = (success: boolean, message: string) => {
        if (!feedbackElement) return;
        feedbackElement.innerText = message;
        feedbackElement.classList.remove('investi-success', 'investi-error');
        feedbackElement.classList.add(success ? 'investi-success' : 'investi-error');
      };

      const lastUsedBadge = (): HTMLSpanElement => {
        const badge = document.createElement('span');
        badge.className = 'investi-login__last-used';
        badge.innerText = 'Last used';
        return badge;
      };

      const makeField = (type: string, labelText: string, className: string): { field: HTMLDivElement, input: HTMLInputElement } => {
        const field = document.createElement('div');
        field.className = 'investi-login__field';
        const label = document.createElement('label');
        label.innerText = labelText;
        const input = document.createElement('input');
        input.type = type;
        input.className = `investi-login__${className}`;
        input.name = input.className;
        input.id = input.className;
        label.htmlFor = input.id;
        field.append(label, input);
        return { field, input };
      };

      const makeSubmit = (text: string): { wrap: HTMLDivElement, submit: HTMLButtonElement } => {
        const wrap = document.createElement('div');
        wrap.className = 'investi-login__btn-wrap';
        const submit = document.createElement('button');
        submit.type = 'button';
        submit.className = 'investi-login__submit';
        submit.innerText = text;
        wrap.append(submit);
        return { wrap, submit };
      };

      const appendFeedback = () => {
        feedbackElement = document.createElement('div');
        feedbackElement.className = 'investi-login__feedback';
        elem.append(feedbackElement);
      };

      const clearFeedback = () => {
        feedbackElement.innerText = '';
        feedbackElement.classList.remove('investi-success', 'investi-error');
      };

      //sent here to log in (e.g. to comment on an announcement)? same-origin page to go back to
      const getReturnUrl = (): string | null => {
        const returnUrl = new URLSearchParams(window.location.search).get('returnUrl');
        if (returnUrl && new URL(returnUrl, window.location.origin).origin === window.location.origin) return returnUrl;
        return null;
      };

      const renderRedirecting = (returnUrl: string) => {
        elem.innerHTML = '';
        const redirecting = document.createElement('div');
        redirecting.className = 'investi-login__signed-in';
        redirecting.innerText = 'Signed in, redirecting…';
        elem.append(redirecting);
        window.location.href = returnUrl;
      };

      const renderSignedIn = (me: {name: string, email: string}) => {
        const returnUrl = getReturnUrl();
        if (returnUrl) {
          renderRedirecting(returnUrl);
          return;
        }
        elem.innerHTML = '';
        const signedIn = document.createElement('div');
        signedIn.className = 'investi-login__signed-in';
        signedIn.innerText = `Signed in as ${me.name} (${me.email})`;
        const signOut = document.createElement('button');
        signOut.type = 'button';
        signOut.className = 'investi-login__signout';
        signOut.innerText = 'Sign out';
        signOut.addEventListener('click', async () => {
          try { await this.httpCall('POST', `${this.authBaseAddress}/api/auth/logout`, {}, true); } catch (e) { }
          renderForm();
        });
        elem.append(signedIn, signOut);
      };

      const renderForm = () => {
        elem.innerHTML = '';
        feedbackElement = null;
        const lastUsed = localStorage.getItem(lastUsedStorageKey);

        const heading = document.createElement('h1');
        heading.className = 'investi-login__heading';
        heading.innerText = elem.getAttribute('data-investi-login-heading') || (companyName ? `Sign in to ${companyName}` : 'Sign in');
        elem.append(heading);

        const intro = document.createElement('div');
        intro.className = 'investi-login__intro';
        intro.innerText = 'Enter your email and we\'ll send you a sign-in code. No password needed.';
        elem.append(intro);

        const emailField = makeField('email', 'Email', 'email');
        const email = emailField.input;
        elem.append(emailField.field);

        const { wrap: submitWrap, submit } = makeSubmit('Email me a sign-in code');
        if (lastUsed === 'email') submitWrap.append(lastUsedBadge());
        elem.append(submitWrap);

        const divider = document.createElement('div');
        divider.className = 'investi-login__divider';
        divider.innerText = 'or';
        elem.append(divider);

        const openPopup = (provider: string) => {
          const returnUrl = window.location.href;
          const url = `${this.authBaseAddress}/api/auth/${provider}-login?apiKey=${encodeURIComponent(key)}&returnUrl=${encodeURIComponent(returnUrl)}`;
          const w = 500, h = 600;
          const left = window.screenX + (window.outerWidth - w) / 2;
          const top = window.screenY + (window.outerHeight - h) / 2;
          window.open(url, 'investi-login', `width=${w},height=${h},left=${left},top=${top}`);
        };

        const socialContainer = document.createElement('div');
        socialContainer.className = 'investi-login__social';

        const makeSocialButton = (provider: string, className: string, html: string): HTMLDivElement => {
          const wrap = document.createElement('div');
          wrap.className = 'investi-login__btn-wrap';
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = className;
          btn.innerHTML = html;
          btn.addEventListener('click', () => openPopup(provider));
          wrap.append(btn);
          if (lastUsed === provider) wrap.append(lastUsedBadge());
          return wrap;
        };

        socialContainer.append(makeSocialButton('google', 'investi-login__google-btn',
          `<svg viewBox="0 0 24 24" width="18" height="18"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg> Google`));

        socialContainer.append(makeSocialButton('linkedin', 'investi-login__linkedin-btn',
          `<svg viewBox="0 0 24 24" width="18" height="18"><path fill="#0A66C2" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg> LinkedIn`));

        elem.append(socialContainer);

        const socialNote = document.createElement('div');
        socialNote.className = 'investi-login__social-note';
        socialNote.innerText = 'One-click login';
        elem.append(socialNote);

        const legal = document.createElement('div');
        legal.className = 'investi-login__legal';
        legal.innerHTML = `By continuing, you agree to our <a href="https://web.investi.com.au/terms-of-service/" target="_blank" rel="noopener">Terms</a> and <a href="https://web.investi.com.au/privacy-policy/" target="_blank" rel="noopener">Privacy Policy</a>.`;
        elem.append(legal);

        appendFeedback();

        submit.addEventListener('click', async () => {
          submit.disabled = true;
          clearFeedback();
          try {
            const result = await this.httpCall<{success: boolean, message?: string, newUser?: boolean, fromEmail?: string}>('POST',
              `${this.authBaseAddress}/api/auth/request-code`, { apiKey: key, email: email.value }, true);
            if (result.success) {
              renderCodeStep(email.value.trim(), result.newUser, result.fromEmail);
            } else {
              showFeedback(false, result.message || 'Something went wrong. Please try again.');
            }
          } catch (e) {
            showFeedback(false, 'Something went wrong. Please try again.');
          }
          submit.disabled = false;
        });
      };

      const renderCodeStep = (emailAddress: string, newUser: boolean, fromEmail?: string) => {
        elem.innerHTML = '';

        const heading = document.createElement('h1');
        heading.className = 'investi-login__heading';
        heading.innerText = 'Check your email';
        elem.append(heading);

        const sent = document.createElement('div');
        sent.className = 'investi-login__sent';
        sent.innerText = `We've emailed a sign-in code to ${emailAddress} from ${fromEmail || 'Investi Services'}. It can take a minute to arrive — check your spam/junk folder too.`;
        elem.append(sent);

        let firstName: HTMLInputElement = null, lastName: HTMLInputElement = null;
        if (newUser) {
          const firstNameField = makeField('text', 'First Name', 'first-name');
          const lastNameField = makeField('text', 'Last Name', 'last-name');
          firstName = firstNameField.input;
          lastName = lastNameField.input;
          elem.append(firstNameField.field, lastNameField.field);
        }

        const codeField = makeField('text', 'Sign-in code', 'code');
        const code = codeField.input;
        code.inputMode = 'numeric';
        code.autocomplete = 'one-time-code';
        elem.append(codeField.field);

        const { wrap: submitWrap, submit } = makeSubmit('Sign in');
        elem.append(submitWrap);

        const toggle = document.createElement('div');
        toggle.className = 'investi-login__toggle';
        const resend = document.createElement('a');
        resend.innerText = 'Resend code';
        resend.addEventListener('click', async () => {
          clearFeedback();
          try {
            const result = await this.httpCall<{success: boolean, message?: string}>('POST',
              `${this.authBaseAddress}/api/auth/request-code`, { apiKey: key, email: emailAddress }, true);
            showFeedback(result.success, result.success ? 'Code re-sent — check your inbox and spam/junk folder.'
              : (result.message || 'Something went wrong. Please try again.'));
          } catch (e) {
            showFeedback(false, 'Something went wrong. Please try again.');
          }
        });
        const back = document.createElement('a');
        back.innerText = 'Use a different email';
        back.addEventListener('click', () => renderForm());
        toggle.append(resend, document.createTextNode(' · '), back);
        elem.append(toggle);

        appendFeedback();

        submit.addEventListener('click', async () => {
          submit.disabled = true;
          clearFeedback();
          try {
            const result = await this.httpCall<{success: boolean, message?: string, name?: string, email?: string}>('POST',
              `${this.authBaseAddress}/api/auth/verify-code`, {
                apiKey: key,
                email: emailAddress,
                code: code.value,
                firstName: firstName ? firstName.value : '',
                lastName: lastName ? lastName.value : ''
              }, true);
            if (result.success) {
              localStorage.setItem(lastUsedStorageKey, 'email');
              renderSignedIn({name: result.name, email: result.email});
            } else {
              showFeedback(false, result.message || 'Something went wrong. Please try again.');
            }
          } catch (e) {
            showFeedback(false, 'Something went wrong. Please try again.');
          }
          submit.disabled = false;
        });
      };

      // Result posted back from the social login popup
      window.addEventListener('message', (event) => {
        if (event.data?.type !== 'investi-login') return;
        if (event.data.status === 'success') {
          localStorage.setItem(lastUsedStorageKey, event.data.provider);
          // popup already confirmed the login, so skip the /me round trip
          const returnUrl = getReturnUrl();
          if (returnUrl) renderRedirecting(returnUrl);
          else refresh();
        } else {
          showFeedback(false, event.data.message || 'Something went wrong. Please try again.');
        }
      });

      const refresh = async () => {
        try {
          const me = await this.httpCall<{loggedIn: boolean, name?: string, email?: string}>('GET', `${this.authBaseAddress}/api/auth/me`, null, true);
          if (me.loggedIn) renderSignedIn({name: me.name, email: me.email});
          else renderForm();
        } catch (e) {
          renderForm();
        }
      };

      // Fetch company name before first render so the heading is correct from the start
      this.getMarketData(key,
        (container) => {
          companyName = container.marketData?.companyName || '';
          refresh();
        },
        () => refresh());
    });
  }

  //site header: Register / Login link to the login page, or the signed-in name with a Logout menu
  createInvestiNavAccountWidget(){

    this.doActionOnIdOrClass(NavAccountWidgetName, (elem) => {

      const loginLink = elem.getAttribute('data-investi-login-link');
      if (!loginLink) console.warn(`${NavAccountWidgetName}: data-investi-login-link is required`);

      const makeLink = (text: string, className: string): HTMLAnchorElement => {
        const sep = (loginLink || '').includes('?') ? '&' : '?';
        const link = document.createElement('a');
        link.className = `investi-nav-account__${className}`;
        link.href = `${loginLink || ''}${sep}returnUrl=${encodeURIComponent(window.location.pathname)}`;
        link.innerText = text;
        return link;
      };

      const renderSignedOut = (loading = false) => {
        elem.innerHTML = '';
        elem.classList.toggle('investi-nav-account--loading', loading);
        elem.append(makeLink('Register / Login', 'register-login'));
      };

      const renderSignedIn = (name: string) => {
        elem.innerHTML = '';
        elem.classList.remove('investi-nav-account--loading');
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'investi-nav-account__toggle';
        toggle.innerText = name;
        toggle.setAttribute('aria-expanded', 'false');
        const menu = document.createElement('div');
        menu.className = 'investi-nav-account__menu';
        menu.hidden = true;
        const logout = document.createElement('button');
        logout.type = 'button';
        logout.className = 'investi-nav-account__item';
        logout.innerText = 'Logout';
        logout.addEventListener('click', async () => {
          try { await this.httpCall('POST', `${this.authBaseAddress}/api/auth/logout`, {}, true); } catch (e) { }
          renderSignedOut();
        });
        toggle.addEventListener('click', () => {
          menu.hidden = !menu.hidden;
          toggle.setAttribute('aria-expanded', String(!menu.hidden));
        });
        menu.append(logout);
        elem.append(toggle, menu);
      };

      document.addEventListener('click', (e) => {
        const menu = elem.querySelector<HTMLElement>('.investi-nav-account__menu');
        if (menu && !elem.contains(e.target as Node)) menu.hidden = true;
      });

      renderSignedOut(true);
      this.httpCall<{loggedIn: boolean, name?: string}>('GET', `${this.authBaseAddress}/api/auth/me`, null, true)
        .then(me => me.loggedIn ? renderSignedIn(me.name) : renderSignedOut())
        .catch(() => renderSignedOut());
    });
  }


  create() {
    this.createInvestiSharePriceWidget();
    this.createInvestiSharePriceTable();
    this.createInvestiMarketDataIndividualFields();
    this.createInvestiChart();
    this.createInvestiAnnouncementTable();
    this.createInvestiAnnouncementsInteractiveTable();
    this.createInvestiAnnouncementSummary();
    this.createInvestiHeaderWidget();
    this.createinvestiPriceOnTopWidget();
    this.createHeaderPrice();
    this.createInvestiAnnouncementAccordion();
    this.createCarousel();
    this.createAnnouncementsThumbnail();
    this.createInvestiAnnouncementSummary_v2();
    this.createStoriBotWidget();
    this.createInvestiAnnouncementTab();
    this.createSecFilingsWidget();
    this.createAddSubscriberWidget();
    this.createInvestiLoginWidget();
    this.createInvestiNavAccountWidget();
  }

  start(){

    widget.sendPageView();

    let promises:Promise<void>[] = [];
    if(widget.shouldPollMarketData()){
      promises = widget.apiKeys.map(x => {
        return new Promise<void>((resolve, reject) =>{
          widget.getMarketData(x.apiKey, data => resolve(), err => resolve())
        });
      });
    }

    if(widget.hasAnnouncementWidget()){
      promises.push(...widget.apiKeys.map(x => {
        return new Promise<void>((resolve, reject) =>{
          widget.getAnnouncementData(x.apiKey,data => resolve(), err => resolve())
        });
      }));
    }


    Promise.all(promises).then(()=>{
      widget.create();
    }).catch(console.error);
  }

};

class PdfViewer{

  pdfDoc:any = null;
  pageNum:number = 1;
  pageRendering:boolean = false;
  pageNumPending:any = null;
  canvas:HTMLCanvasElement;
  ctx:CanvasRenderingContext2D
  elem:HTMLElement
  pageCountElem:HTMLElement
  pageNumElem:HTMLElement
  loadingElem:HTMLElement
  canvasHeader:HTMLElement
  infoElem:HTMLElement
  errorLoadingElem:HTMLAnchorElement
  announcementLink:HTMLAnchorElement
  announcementHeadline:HTMLElement
  hide:boolean;
  textLayer:HTMLElement
  textLayerTask:any = null;
  pageWidth:number = 0;

  constructor(elem:HTMLElement){
    this.elem = elem;
    this.hide = elem.hasAttribute('data-investi-interactive-announcements-hide-pdf-viewer');
    this.canvas = elem.querySelector('.investi-pdf-canvas') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.textLayer = elem.querySelector('.investi-pdf-page .textLayer') as HTMLElement;
    new ResizeObserver(() => this.updateTextLayerScale()).observe(this.canvas);
    (elem.querySelector('.investi-pdf-prev-page-btn') as HTMLElement).onclick = this.onPrevPage.bind(this);
    (elem.querySelector('.investi-pdf-next-page-btn') as HTMLElement).onclick = this.onNextPage.bind(this);
    this.pageCountElem = this.elem.querySelector('.investi-pdf-page-count');
    this.pageNumElem = this.elem.querySelector('.investi-pdf-page-num');
    this.loadingElem = this.elem.querySelector('.investi-loading');
    this.canvasHeader = this.elem.querySelector('.investi-pdf-buttons');
    this.infoElem = this.elem.querySelector('.investi-pdf-info');
    this.errorLoadingElem = this.elem.querySelector('.investi-pdf-error-loading');
    this.announcementLink = this.elem.querySelector('.investi-pdf-announcement-link') as HTMLAnchorElement;
    this.announcementHeadline = this.elem.querySelector('.investi-pdf-info-announcement-headline') as HTMLElement;
  }
  queueRenderPage(num) {
    if (this.pageRendering) {
      this.pageNumPending = num;
    } else {
      this.renderPage(num);
    }
  }

  renderPage(num) {
    this.pageRendering = true;

    // Using promise to fetch the page
    this.pdfDoc.getPage(num).then((page) =>{

      // const scale = window.screen.width >= 1920 ? 2 : 1;
      const scale = 2;
      let viewport = page.getViewport({ scale });

      // var container = document.getElementsByClassName('investi-pdf-canvas-container')[0];
      // console.log('container.clientWidth', container.clientWidth)
      // var scale = container.clientWidth / viewport.width;
      // viewport = page.getViewport(scale);

      this.canvas.height = viewport.height;
      this.canvas.width = viewport.width;

      // Render PDF page into canvas context
      const renderContext = {
        canvasContext: this.ctx,
        viewport: viewport
      };
      const renderTask = page.render(renderContext);
      this.renderTextLayer(page);

      // Wait for rendering to finish
      renderTask.promise.then(()=> {
        this.pageRendering = false;
        this.loadingElem.style.display = 'none';
        if (this.pageNumPending !== null) {
          // New page rendering is pending
          this.renderPage(this.pageNumPending);
          this.pageNumPending = null;
        }
      });
    });

    // Update page counters
    this.pageNumElem.textContent = num;
  }

  //transparent selectable text over the canvas; positions are page-relative, sized by --total-scale-factor
  renderTextLayer(page) {
    this.clearTextLayer();
    const viewport = page.getViewport({ scale: 1 });
    this.pageWidth = viewport.width;
    this.updateTextLayerScale();
    const textLayerTask = new globalThis.pdfjsLib.TextLayer({ textContentSource: page.streamTextContent(), container: this.textLayer, viewport });
    this.textLayerTask = textLayerTask;
    textLayerTask.render().catch((e) => {
      if(e?.name !== 'AbortException') console.error(e);
    });
  }

  clearTextLayer() {
    this.textLayerTask?.cancel();
    this.textLayerTask = null;
    this.textLayer.replaceChildren();
  }

  updateTextLayerScale() {
    if(!this.pageWidth) return;
    this.textLayer.style.setProperty('--total-scale-factor', `${this.canvas.clientWidth / this.pageWidth}`);
  }

  onPrevPage() {
    if (this.pageNum <= 1) {
      return;
    }
    this.pageNum--;
    this.queueRenderPage(this.pageNum);
  }



  onNextPage() {
    if (this.pageNum >= this.pdfDoc.numPages) {
      return;
    }
    this.pageNum++;
    this.queueRenderPage(this.pageNum);
  }

  setPdfInfo(info:HTMLElement, announcement:Announcement,href:string):void{
    this.announcementHeadline.innerText = announcement.headline;
    this.announcementLink.href = href;

  }
  async setPdf(announcement:Announcement, href:string){
    this.setPdfInfo(this.infoElem, announcement, href);

    this.errorLoadingElem.style.display = 'none';
    this.canvasHeader.style.visibility = "hidden"
    this.canvas.style.visibility = "hidden"
    this.clearTextLayer();
    this.pageNum = 1;
    if(!this.hide){
      this.loadingElem.style.display = 'initial';
      const pdfjsLib = globalThis.pdfjsLib;
      pdfjsLib.GlobalWorkerOptions.workerSrc = InvestiWidget.getPdfJsScriptWork();
      try {
        // withCredentials so the investi_user cookie reaches the nginx access log
        const pdfDoc_ = await (pdfjsLib.getDocument({ url: href, withCredentials: true }).promise);
        this.pdfDoc = pdfDoc_;
        this.pageCountElem.textContent = this.pdfDoc.numPages;
        this.canvas.style.visibility = "visible"
        this.canvasHeader.style.visibility = "visible"
        this.renderPage(this.pageNum);
      } catch (e) {
        console.error(e)
        this.loadingElem.style.display = 'none';
        this.errorLoadingElem.style.display = 'block';
      }

    }else{
      this.canvasHeader.style.display = "none"
      this.canvas.style.display = "none"
    }

  }
}


const widget = new InvestiWidget();
widget.start();
// Attach it to the window object for global access
(window as any).investi_widget = widget;